import "../scss/bundle.scss";
import LocomotiveScroll from 'locomotive-scroll';
import smoothscroll from 'smoothscroll-polyfill';
import gsap from 'gsap';
import axios from 'axios';
import ScrollToPlugin from "gsap/ScrollToPlugin";
import MotionPathPlugin from "gsap/MotionPathPlugin";
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(MotionPathPlugin);
import Draggabilly from 'draggabilly';
import SimpleBar from 'simplebar';
import Swiper from 'swiper';
import { Navigation } from 'swiper';
Swiper.use([Navigation]);

let awdScroll;

let doc = document.documentElement;
let $ = jQuery;
let html = document.querySelector('html');
let body = document.querySelector('body');
let hh = window.innerHeight;
let ww = window.innerWidth;
let mousePos = {x: ww/2, y: hh/2};
var scrollTop = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
let scrollLeft = 0;
let globalDirection = 'right';

let homeUrl = document.getElementById('homeUrl').getAttribute('data-homeurl');
let language = document.getElementById('language').getAttribute('data-language');

let colorRed = '#8c0d22';
let colorBrown = '#331f14';
let colorGold = '#C09947';

let classHeader;
let classSelectCategorieMobile;
let classFiltriShop;
let globalSearchForm;


const validateEmail = (email) => {
	let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
};

const calcScrollTop = (instance) => {
	scrollTop = instance.scroll.y;
	return scrollTop;
}
const calcScrollLeft = (instance) => {
	scrollLeft = instance.scroll.x;
	return scrollLeft;
}
const detectDirection = (instance) => {
	globalDirection = instance.direction;
	return globalDirection;
}

function calcWinsize(){
	return {width:window.innerWidth, height:window.innerHeight}
}
let winsize = calcWinsize();
window.addEventListener('resize', () => {
	winsize = calcWinsize();
})

const getMousePos = (e) => {
	let posx = 0;
	let posy = 0;
	if(!e) e = window.event;
	if(e.pageX || e.pageY){
		posx = e.pageX;
		posy = e.pageY;
	}
	else if(e.clientX || e.clientY){
        posx = ev.clientX + body.scrollLeft + docEl.scrollLeft;
        posy = ev.clientY + body.scrollTop + docEl.scrollTop;
	}
	// console.log('posx: ',posx);
	// console.log('posy: ',posy);
	return {x:posx, y:posy}
};
window.addEventListener('mousemove', ev => {
	mousePos = getMousePos(ev);
	// console.log('mousePos.x: ',mousePos.x);
	// console.log('mousePos.y: ',mousePos.y);
});

function isIpadPro() {
	let response;
    let ratio = window.devicePixelRatio || 1;
    let screen = {
        width : window.screen.width * ratio,
        height : window.screen.height * ratio
    };
    if(
    	(screen.width === 2048 && screen.height === 2732) || //iPad Pro Portrait
    	(screen.width === 2732 && screen.height === 2048) || //iPad Pro Landscape
    	(screen.width === 1536 && screen.height === 2048) || //iPad
    	(screen.width === 2048 && screen.height === 1536)){
    	response = true;

    }
    else {
    	response = false;
    }

    return response;
}

const _isMobile =  () => {
	if(winsize.width <= 900 || isIpadPro()){
		return true;
	}
	else{
		return false;
	}
}
let isMobile = _isMobile();


// a and b are javascript Date objects
function dateDiffInDays(a, b) {
    let _MS_PER_DAY = 1000 * 60 * 60 * 24;

    // Discard the time and time-zone information.
    let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      // return Math.floor((utc2 - utc1) / _MS_PER_DAY);
      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}
function cookiePopupNewsletter(){

    if (document.cookie.indexOf("visited=") >= 0) {
      // L'utente era già entrato almeno una volta negli ultimi 5 minuti.
      console.log('gia visitato')

    }
    else {
        // L'utente è almeno da 5 minuti che non visita il sito
    var a = new Date(),
        b = new Date("2021-02-22"), //fino al
        difference = dateDiffInDays(a, b)

        // console.log('differenza',difference)

        //il popup esiste fino al 22 febbraio 2019
        if(difference >= 0){
            let expiry = new Date();
            let unMinuto = 60*1000;
            expiry.setTime(expiry.getTime()+(unMinuto*60*24*4)); //4 giorni

            //Creo il cookie 'visited' e lo setto a 'yes'. Infine ne imposto la scadenza
            document.cookie = "visited=yes; expires=" + expiry.toGMTString();
            setTimeout(function(){
                popupNewsletter()
            },3000)
        }


    }
}
function popupNewsletter(){
    gsap.to($('.popup-newsletter'),{
		duration:0.8,
		autoAlpha:1
	})
    let chiudiPopup = document.querySelectorAll('.js-chiudi-popup');
    let popup = document.querySelector('.popup-newsletter');
    chiudiPopup.forEach( btn => {
        btn.addEventListener('click', () => {
            gsap.to(popup,{
                duration:0.8,
                autoAlpha:0
            })
        })
    })
}

function openHamburger(){
	let duration = 0.3;
	let boundHamburger = document.querySelector('.hamburger__wrapper').getBoundingClientRect();
	let boundSpanCenter = document.querySelector('.hamburger .span__wrapper.center').getBoundingClientRect();
	let spanCenterTop = boundSpanCenter.top - boundHamburger.top;

	gsap.to(document.querySelector('.span__wrapper.top'),{
		duration:duration,
		top:spanCenterTop,
		ease:'Power4.in'
	});
	gsap.to(document.querySelector('.span__wrapper.top'),{
		duration:duration,
		rotation:45,
		delay:0.3
	});
	gsap.to(document.querySelector('.span__wrapper.bottom'),{
		duration:duration,
		bottom:spanCenterTop,
		ease:'Power4.in'
	});
	gsap.to(document.querySelector('.span__wrapper.bottom'),{
		duration:duration,
		rotation:-45,
		delay:0.3
	});
	gsap.to(document.querySelector('.span__wrapper.center'),{
		duration:0,
		autoAlpha:0,
		delay:duration
	});

}

function closeHamburger(){
	let duration = 0.3;
	gsap.to(document.querySelector('.span__wrapper.top'),{
		duration:duration,
		rotation:0
	});
	gsap.to(document.querySelector('.span__wrapper.top'),{
		duration:duration,
		top:0,
		delay:0.3,
		ease:'Power4.in'
	});
	gsap.to(document.querySelector('.span__wrapper.bottom'),{
		duration:duration,
		rotation:0
	});
	gsap.to(document.querySelector('.span__wrapper.bottom'),{
		duration:duration,
		bottom:0,
		ease:'Power4.in',
		delay:0.3
	});
	gsap.to(document.querySelector('.span__wrapper.center'),{
		duration:0,
		autoAlpha:1,
		delay:duration
	});
}

function openMenu(){
	let duration = 1.2;
	let menu = document.querySelector('.menu');
	let menuBg = menu.querySelector('.menu__bg');
	let menuItems = menu.querySelectorAll('.link__item');
	let menuItemCount = menuItems.length;
	let staggerDuration = (menuItemCount*0.12) + 1;
	let lettereSvg = menu.querySelector('.menu__svg');

	let links = document.querySelector('header .links');
	// let headerRight = document.querySelector('.header__right');
	let subHeader;
	let menuLinguaSocial = menu.querySelectorAll('.menu__lingua-e-social');
	let subHeaderDelay = 0;
	if(document.querySelector('.subheader') !== null){
		subHeader = document.querySelector('.subheader');
		subHeaderDelay = 0.15;
	}

	let delayMenuIcone = 0.8;
	let wrapMenuIconeMobile = document.querySelector('.menu__icone');
	let menuIconeMobile = document.querySelectorAll('.menu__icona');

	//Nella pagina contatti devo customizzare il comportamento del header all'aperture del menu
	if(document.querySelector('.page-contatti') !== null){
		let headerBgSpan = document.querySelector('.header__bg span');
		let headerSale = document.querySelector('.header__sale');
		gsap.to(headerBgSpan,{
			duration:0,
			opacity:0
		})
		gsap.to(headerSale,{
			duration:0,
			opacity:0
		})
	}


	openHamburger();
	//IG, FB, EN, IT
	// gsap.to(menuLinguaSocial,{
	// 	duration:1,
	// 	autoAlpha:1,
	// 	delay:0.8,
	// 	ease:'power1.in'
	// })
	// gsap.to(menuLinguaSocial,{
	// 	duration:1,
	// 	y:0,
	// 	delay:0.8,
	// 	ease:'power2.out'
	// })

	//LETTERE SVG SCRITTA 'MENU'
	gsap.to(lettereSvg,{
		duration:0.6,
		delay:0.4,
		autoAlpha:1
	})

	//ICONE LOGINE E WISHLIST MOBILE SOTTO L'HAMBURGER
	wrapMenuIconeMobile.style.visibility = 'visible';
	menuIconeMobile.forEach(icona => {
		gsap.to(icona,{
			duration:0.5,
			autoAlpha:1,
			// delay:delayMenuIcone,
			// ease:'power1.in'
		})
		// gsap.to(icona,{
		// 	duration:1,
		// 	y:0,
		// 	delay:delayMenuIcone,
		// 	ease:'power2.out'
		// })
		// delayMenuIcone+=0.05;
	})

	if(isMobile){
		return new Promise( (resolve, reject) =>{
			gsap.timeline({onComplete:resolve})
				.add( () => {
					if(awdScroll){
						// console.log(scroll)
						awdScroll.stop();
					}
					else{
						TweenMax.set(body,{
							overflow:'hidden'
						})
					}

				})

				//set menu visible
				.to(menu,{
					duration:0,
					autoAlpha:1,
				})
				.add( () => {
					if(document.querySelector('.subheader') !== null){
						gsap.to(subHeader,{
							duration:0.2,
							autoAlpha:0
						})
					}
				})
				.to(menuBg,{
					duration:0.6,
					autoAlpha:1
				},'+='+subHeaderDelay)
				.to(links,{
					duration:0.45,
					autoAlpha:0
				},'-=0.6')
				.to(menuItems,{
					duration:0.5,
					autoAlpha:1,
					// stagger: {
					// 	each:0.12
					// }
				},'-=0.3')


		})
	}
	else{
		return new Promise( (resolve, reject) =>{
			gsap.timeline({onComplete:resolve})
				.add( () => {
					if(awdScroll){
						// console.log(scroll)
						awdScroll.stop();
					}
					else{
						TweenMax.set(body,{
							overflow:'hidden'
						})
					}

				})

				//set menu visible
				.to(menu,{
					duration:0,
					autoAlpha:1,
				})
				.add( () => {
					if(document.querySelector('.subheader') !== null){
						gsap.to(subHeader,{
							duration:0.2,
							autoAlpha:0
						})
					}
				})
				.to(menuBg,{
					duration:0.6,
					autoAlpha:1
				},'+='+subHeaderDelay)
				.to(links,{
					duration:0.45,
					autoAlpha:0
				},'-=0.6')
				.to(menuItems,{
					duration:1,
					autoAlpha:1,
					ease:"power1.in",
					stagger: {
						each:0.12
					}
				},'-=0.3')
				.to(menuItems,{
					duration:1,
					y:0,
					ease:"power2.out",
					stagger: {
						each:0.12
					}
				},'-='+staggerDuration)


		})
	}




}

function closeMenu(){
	let menu = document.querySelector('.menu');
	let menuBg = menu.querySelector('.menu__bg');
	let menuItems = menu.querySelectorAll('.link__item');
	let links = document.querySelector('header .links');
	let headerRight = document.querySelector('.header__right');
	let subHeader;
	let menuLinguaSocial = menu.querySelectorAll('.menu__lingua-e-social');
	let lettereSvg = menu.querySelector('.menu__svg');
	if(document.querySelector('.subheader') !== null){
		subHeader = document.querySelector('.subheader');
	}

	// let delayMenuIcone = 0.8;
	let wrapMenuIconeMobile = document.querySelector('.menu__icone');
	let menuIconeMobile = document.querySelectorAll('.menu__icona');

	closeHamburger();
	gsap.to(menuLinguaSocial,{
		duration:0,
		autoAlpha:0,
		y:60,
		delay:0.8,
		ease:'power1.in'
	})
	gsap.to(lettereSvg,{
		duration:0.6,
		autoAlpha:0
	})

	//ICONE LOGINE E WISHLIST MOBILE SOTTO L'HAMBURGER
	menuIconeMobile.forEach(icona => {
		gsap.to(icona,{
			duration:0.4,
			autoAlpha:0,
			onComplete: () => {
				wrapMenuIconeMobile.style.visibility = 'hidden';
				// gsap.to(icona,{
				// 	duration:0,
				// 	y:40
				// })
			}
		})

	})
	if(isMobile){
		return new Promise( (resolve,reject) => {
			gsap.timeline({onComplete:resolve})
				.to(menu,{
					duration:0.3,
					autoAlpha:0
				})
				.to(links,{
					duration:0.45,
					autoAlpha:1
				},'-=0.45')
				.add( () => {
					if(document.querySelector('.subheader') !== null){
						gsap.to(subHeader,{
							duration:0.3,
							autoAlpha:1
						})
					}
				},'-=0.45')
				.add( () => {
					if(awdScroll){
						awdScroll.start();
					}
					else{
						TweenMax.set(body,{
							overflow:'visible'
						})
					}
				})
				.to(menuBg,{
					duration:0,
					autoAlpha:0
				})
				.add( () => {
					//Nella pagina contatti devo customizzare il comportamento del header all'aperture del menu
					if(document.querySelector('.page-contatti') !== null){
						let headerBgSpan = document.querySelector('.header__bg span');
						let headerSale= document.querySelector('.header__sale');
						gsap.to(headerBgSpan,{
							duration:0,
							opacity:1
						})
						gsap.to(headerSale,{
							duration:0,
							opacity:1
						})
					}
				} )


		})
	}
	else{
		return new Promise( (resolve,reject) => {
			gsap.timeline({onComplete:resolve})
				.to(menu,{
					duration:0.3,
					autoAlpha:0
				})
				.to(links,{
					duration:0.45,
					autoAlpha:1
				},'-=0.45')
				.add( () => {
					if(document.querySelector('.subheader') !== null){
						gsap.to(subHeader,{
							duration:0.3,
							autoAlpha:1
						})
					}
				},'-=0.45')
				.to(menuItems,{
					duration:0,
					y:50,
					autoAlpha:0

				})
				.add( () => {
					if(awdScroll){
						awdScroll.start();
					}
					else{
						TweenMax.set(body,{
							overflow:'visible'
						})
					}
				})
				.to(menuBg,{
					duration:0,
					autoAlpha:0
				})
				.add( () => {
					//Nella pagina contatti devo customizzare il comportamento del header all'aperture del menu
					if(document.querySelector('.page-contatti') !== null){
						let headerBgSpan = document.querySelector('.header__bg span');
						let headerSale= document.querySelector('.header__sale');
						gsap.to(headerBgSpan,{
							duration:0,
							opacity:1
						})
						gsap.to(headerSale,{
							duration:0,
							opacity:1
						})
					}
				} )


		})
	}

}

function clickHamburger(){
	let isAnimating = false;
	let hamburgerHitArea = document.querySelector('.hamburger__hit-area');

	hamburgerHitArea.addEventListener('click', () => {

		//apro menu
		if(!hamburgerHitArea.classList.contains('opened')){
			if(isAnimating) return;
			isAnimating = true;
			// clickFeedback();
			body.classList.add('header-bloccato');
			if(document.querySelector('.icona--search') !== null && document.querySelector('.icona--search').classList.contains('opened')){

				if(globalSearchForm.isOpening) return;
				globalSearchForm.isOpening = true;
				globalSearchForm.closeSearchPage();
					openMenu().then( () => {
						isAnimating = false;
					});

			}
			else{
				openMenu().then( () => {
					isAnimating = false;
				});
			}
			hamburgerHitArea.classList.add('opened');
		//chiudo menu
		} else {
			if(isAnimating) return;
			isAnimating = true;
			body.classList.remove('header-bloccato');
			closeMenu().then( () => {
				isAnimating = false;
			});
			hamburgerHitArea.classList.remove('opened');
		}

	})
}


// function lazyLoadMobile(){
// 	console.log('init lazy')
// 	let lazyImages = document.querySelectorAll('.lazy-image-mobile');
// 	awdScroll.on('call', (value) => {

// 		// lazyImages.forEach(image => {
// 			// let delay = image.dataset.delay ? image.dataset.delay : 0;
// 			if(value == 'lazyImageMobile'){
// 				console.log('viewed')
// 				// requestAnimationFrame( () => this.draw() );
// 			}
// 		// })
// 	})
// }

class SlideDouble{
	constructor(slide){
		this.DOM = {slide: slide}
		this.DOM.imgWrap = this.DOM.slide.querySelector('.slide__wrapper');
		this.DOM.img = this.DOM.slide.querySelector('img');

	}

	setCenter(){
		this.isCenter = true;
		this.DOM.slide.classList.add('slide--center');
		gsap.to(this.DOM.slide,{
			duration:0,
			autoAlpha:1,
			'z-index': 21
		})
	}


	reset(){
		gsap.to([this.DOM.imgWrap],{
			duration:0,
			transform:'none'
		})
		gsap.to(this.DOM.slide,{
			duration:0,
			x:0,
			autoAlpha:0,
			'z-index':11
		})
		this.DOM.slide.classList.remove('slide--center');
		// this.DOM.slide.classList.remove('slide--next');
	}

	move(direction){
		return new Promise( resolve => {
			let tx = -1;
			if(direction === 'right'){
				tx = 1;
			}
			gsap.to(this.DOM.imgWrap,{
				duration:1.2,
				x:tx*100+'%',
				ease:'power1.inOut',
				onComplete: () => resolve()
			})
		})


	}
}

class Dot{
	constructor(dot){
		this.DOM = {dot:dot};
		// this.DOM.dotWrapper = this.DOM.dot.querySelector('.dot__wrapper');
		this.DOM.svgCircle = this.DOM.dot.querySelector('.svg-circle');

		//!Per il calcolo della circonferenza da usare poi per lo strokeDasharray,
		//! negli svg circle quello che conta come raggio non è il getBoundingClientRect().width,
		//! ma è l'attributo cx (o cy), in pratica è un valore fisso che non cambia ridimensionando
		//! l'immagine
		// this.raggio = this.DOM.dot.getBoundingClientRect().width / 2; //!Vecchio modo, sbagliato, di calcolare il raggio
		this.raggio = this.DOM.svgCircle.getAttribute('cx');
		this.svgCircleLargeLength = Math.round(2*Math.PI*this.raggio);



	}

	setCenter(){
		this.DOM.dot.classList.add('dot--center');
	}


	reset(){
		this.DOM.dot.classList.remove('dot--center');
	}
	move(){
		return new Promise( resolve => {
			if(this.DOM.dot.classList.contains('dot--center')){
				gsap.to(this.DOM.svgCircle,{
					duration:1,
					strokeDasharray: 0,
					onComplete: () => resolve()
				});
			}
			else{
				gsap.to(this.DOM.svgCircle,{
					duration:1,
					strokeDasharray: this.svgCircleLargeLength,
					onComplete: () => {
						resolve()
					}
				});
			}
		})
	}
}

class SlideshowDouble{
	constructor(el){
		this.DOM = {el:el}
		this.arraySlidesBig = [...this.DOM.el.querySelectorAll('.slider--big .slide')].map( slide => new SlideDouble(slide));
		this.arraySlidesSmall = [...this.DOM.el.querySelectorAll('.slider--small .slide')].map( slide => new SlideDouble(slide));
		this.arrayDots = [...this.DOM.el.querySelectorAll('.dot')].map( dot => new Dot(dot));

		this.totalSlides = this.arraySlidesBig.length;

		if( this.totalSlides < 2) return;

		this.center = 0;

		this.isAnimating = false;

		// this.DOM.control = this.DOM.el.querySelector('.control--next');

        this.setVisibleSlides();
        this.initEvents();

	}

	initEvents(){
		// this.DOM.control.addEventListener('click', () => {
		// 	this.navigate();
		// });
		this.arrayDots.forEach( dotClass => {
			dotClass.DOM.dot.addEventListener('click', () => {
				let dot = dotClass.DOM.dot;
				let dotCliccato = dot.dataset.dotNumber;
				let dotCorrente = this.arrayDots[this.center].DOM.dot.dataset.dotNumber
				let diff = Number(dotCliccato) - Number(dotCorrente);
				let direction;
				if(diff == 0) return;
				if(diff > 0){
					direction = 'left';
				}
				else{
					direction = 'right';
				}
				this.navigate(direction,dotCliccato);

			})
		})

	}

	setVisibleSlides(){
		this.centerSlideBig = this.arraySlidesBig[this.center];
		this.centerSlideBig.setCenter();
		this.centerSlideSmall = this.arraySlidesSmall[this.center];
		this.centerSlideSmall.setCenter();
		this.centerDot = this.arrayDots[this.center];
		this.centerDot.setCenter();
	}


	navigate(direction,dotCliccato){
		if(this.isAnimating) return;
		this.isAnimating = true;
		let tx = 1;
		if(direction === 'right'){
			tx = -1
		}

		// const upcomingPos = this.center < this.totalSlides-2 ? this.center+2 : Math.abs(this.totalSlides-2-this.center);
		const upcomingPos = dotCliccato-1;


		// this.center = this.center < this.totalSlides-1 ? this.center+1 : 0;
		this.center = dotCliccato-1;

		this.upcomingSlideBig = this.arraySlidesBig[upcomingPos];
		this.upcomingSlideSmall = this.arraySlidesSmall[upcomingPos];
		this.upcomingDot = this.arrayDots[upcomingPos];

		gsap.to(this.upcomingSlideBig.DOM.slide,{
			duration:0,
			autoAlpha:1,
			x:tx*100+'%'
		})

		gsap.to(this.upcomingSlideSmall.DOM.slide,{
			duration:0,
			autoAlpha:1,
			x:tx*100+'%'
		})

		const movingSlides = [this.centerSlideBig, this.upcomingSlideBig, this.centerSlideSmall, this.upcomingSlideSmall];
		const movingDots = [this.centerDot, this.upcomingDot];
		let promises = movingSlides.map( slide => slide.move(direction));

		movingDots.forEach( dot => {
			promises.push(dot.move());
		})
		// console.log(promises);
		Promise.all(promises).then( () => {
			movingSlides.forEach( slide => slide.reset());
			movingDots.forEach( dot => dot.reset());
			this.setVisibleSlides();
			this.isAnimating = false;
		})

	}




}

class Scrolla{
	constructor(scrolla){
		this.scrolla = scrolla;
		this.scrollaBarSpan = this.scrolla.querySelector('.bar__wrapper span');
		this.isScrolling = false;

		if(document.querySelector('.horizontal-page') === null){
			this.target = hh;
			this.toggleScrollDownVertical();
		}
		else{
			this.target = ww;
			this.toggleScrollDownHorizontal();

		}


		this.clickToScrollDown();

		this.moveBar();
		this.calcResize();
	}

	calcResize(){
		window.addEventListener('resize', () => {
			this.target = document.querySelector('.horizontal-page') !== null ? winsize.width : winsize.height;
		})
	}

	clickToScrollDown(){
		this.scrolla.addEventListener('click', () => {
			if(this.isScrolling) return;
			this.isScrolling = true;
			// let target = hh;
			let options = {
				offset: 0,
				duration: 1200,
				easing: [0.62, 0.02, 0.38, 0.98],
				callback: () => {
					this.isScrolling = false;
					console.log('end')
				}
			}
			// let offset = 0;
			// let duration = 800;
			// let easing = [0.5, 0.00, 0.5, 1.00];
			awdScroll.scrollTo(this.target,options);
			setTimeout( () => {})
		})
	}

	toggleScrollDownVertical(){
		awdScroll.on('scroll', (instance) => {
			if(scrollTop > 120){
				gsap.to(this.scrolla,{
					duration:0.4,
					autoAlpha:0
				})
			}
			else{
				gsap.to(this.scrolla,{
					duration:0.6,
					autoAlpha:1
				})
			}
		})
	}

	toggleScrollDownHorizontal(){
		awdScroll.on('scroll', (instance) => {
			if(scrollLeft > 120){
				gsap.to(this.scrolla,{
					duration:0.4,
					autoAlpha:0
				})
			}
			else{
				gsap.to(this.scrolla,{
					duration:0.6,
					autoAlpha:1
				})
			}
		})
	}

	moveBar(){
		gsap.timeline({repeat:-1})
			.to(this.scrollaBarSpan,{
				duration:1.6,
				x:'100%'
			})
			.to(this.scrollaBarSpan,{
				duration:0,
				x:'-100%'
			})
			.to(this.scrollaBarSpan,{
				duration:1.6,
				x:'0%'
			})
	}
}



class DragGallery{
	constructor(galleryContainer){
		this.galleryContainer = galleryContainer;
		this.control = this.galleryContainer.querySelector('.control');
		this.controlSlides = this.control.querySelectorAll('.control__slide');
		this.controlWidth = this.control.getBoundingClientRect().width;
		this.dragger = this.galleryContainer.querySelector('.dragger');
		this.draggerWidth  = this.dragger.getBoundingClientRect().width;
		this.circleFill = this.dragger.querySelector('.circle-fill');
		this.circleStroke = this.dragger.querySelector('.circle-stroke');
		this.galleries = this.galleryContainer.querySelectorAll('.drag-gallery');
		this.arrayMustHaveLinks = [];
		if(this.galleryContainer.closest('.sezione__gallerie').querySelector('.txt__cta') !== null){
			this.anchorLinkCta = this.galleryContainer.closest('.sezione__gallerie').querySelector('.txt__cta a')
			// console.log(this.anchorLinkCta)
		}
		//! Inizializzo il link al primo prodotto
		// if(this.galleryContainer.querySelector('.drag-slide[data-is-musthave="1"]') !== null){
		// 	[...this.galleryContainer.querySelectorAll('.drag-slide[data-is-musthave="1"]')].forEach( slide => {
		// 		let link = slide.dataset.link
		// 		this.arrayMustHaveLinks.push(link)
		// 		this.anchorLinkCta.setAttribute('href',this.arrayMustHaveLinks[0])
		// 	})
		// }

		this.pointerDownInterval;

        this.prevDirection = 0;
		this.direction = 0;

		[...this.galleries].forEach( gallery => {
			this.quanteSlide = gallery.querySelectorAll('.drag-slide').length;
		})

		this.controlSlidesContainer = this.galleryContainer.querySelector('.control__slides');
		this.controlSlidesContainerWidth = this.controlSlidesContainer.getBoundingClientRect().width;
		this.controlSlideWidth = this.controlSlidesContainerWidth / (this.quanteSlide - 1);
		this.svgDash = this.control.querySelector('.dash .svg-dash');
		this.svgBullet = this.dragger.querySelector('.svg-bullet');
		this.arrowRight = this.dragger.querySelector('.arrow-right .img');
		this.svgArrowRight = this.dragger.querySelector('.arrow-right .svg-arrow');
		this.arrowLeft = this.dragger.querySelector('.arrow-left .img');
		this.svgArrowLeft = this.dragger.querySelector('.arrow-left .svg-arrow');

		this.dragLimit = this.controlWidth - this.draggerWidth;
		// console.log('drag limit: ', this.dragLimit);
		// console.log('this.controlWidth - this.draggerWidth: ', this.controlWidth - this.draggerWidth);


		//Drag bacground color change
		if(document.querySelector('.js-background-element') !== null){
			this.backgroundElement = document.querySelector('.js-background-element');
			this.colorDragStart = this.backgroundElement.dataset.colorDragstart;
			this.colorDragEnd = this.backgroundElement.dataset.colorDragend;
		}
		else{
			this.backgroundElement = document.body;
			this.colorDragStart = this.colorDragEnd = document.body.style.backgroundColor;
		}

		//Call funcions
		this.initEvents();
		this.setDomSizes();
		this.moveGalleries();
	}

	initEvents(){
		this.currents = 1;
		this.draggie = new Draggabilly( this.dragger, {
			axis: 'x',
		});
		this.controlSlides[0].classList.add('control__slide--active');
		this.controlSlides[1].classList.add('control__slide--next');

		window.addEventListener('resize', () => {
			this.setDomSizes();
		})


	}

	//Imposto dei valori arrotondati
	setDomSizes(){
		[...this.galleries].forEach( gallery => {
			// let slideWidth;
			let galleryContainer = gallery.querySelector('.drag-gallery__container');
			let slides = gallery.querySelectorAll('.drag-slide');
			let slideWidth = Math.floor(slides[0].getBoundingClientRect().width)+1;
			// console.log(slideWidth*this.quanteSlide);
			// [...slides].forEach( slide => {
			// 	//Arrotondo il valore della singola slide
			// 	gsap.to(slide,{
			// 		width: slideWidth
			// 	})
			// })
			//Arrotondo il valore della finestra visible
			gsap.to(gallery,{
				duration:0,
				width: slideWidth
			})
			//Arrotondo il valore del container delle slide
			gsap.to(galleryContainer,{
				duration:0,
				width: this.quanteSlide*slideWidth
			})
			//Imposto la lunghezza del contenitore delle control__slide con le qali controllo l'active slider
			// this.dragLimit = this.controlSlidesContainerWidth;
			gsap.to(this.controlSlidesContainer,{
				duration:0,
				width: this.controlSlideWidth*this.quanteSlide
			})

		})
	}

	moveGalleries(){
		[...this.galleries].forEach( (gallery, indexGallery) => {
			let slides = gallery.querySelectorAll('.drag-slide');
			let slideActive = slides[0];
			let slideActiveBoundingrect = slideActive.getBoundingClientRect();
			let slideWidth = slideActiveBoundingrect.width;
			// console.log({slideWidth});
			let galleryContainer = gallery.querySelector('.drag-gallery__container');
			let galleryWrapper = gallery.querySelector('.drag-gallery__wrapper');
			let galleryWidth = galleryContainer.getBoundingClientRect().width;

			let coeff = (galleryWidth - slideWidth) / (this.controlWidth - this.draggerWidth);
			// console.log({coeff});

			//Reset coeff on resize
			window.addEventListener('resize', () => {
				coeff = (galleryContainer.getBoundingClientRect().width - slideActive.getBoundingClientRect().width) / (this.controlWidth - this.draggerWidth);
			})

			this.draggie.on('pointerDown', ( event, pointer, moveVector ) => {
				let tx = this.draggie.position.x;

				gsap.to(this.circleFill,{
					duration:0.3,
					scale:0.6,
					opacity:0.4
				})
				gsap.to(this.circleStroke,{
					duration:0.3,
					scale:0.6,
				})
				gsap.to(this.backgroundElement,{
					// backgroundColor:colorRed
					backgroundColor:this.colorDragStart
				})
				gsap.to(this.svgDash,{
					duration:0.3,
					stroke:colorBrown
				});
				gsap.to(this.svgBullet,{
					duration:0.3,
					fill:colorBrown
				});
				gsap.to(galleryWrapper,{
					duration:0.3,
					webkitClipPath:'polygon(5% 5%, 95% 5%, 95% 95%, 5% 95%)', clipPath:'polygon(5% 5%, 95% 5%, 95% 95%, 5% 95%)', ease: Power1.easeOut
				});
				if(tx < this.dragLimit){
					gsap.to(this.arrowRight,{
						duration:0.3,
						autoAlpha:1,
						x:8
					});
				}

				if(tx > 0){
					gsap.to(this.arrowLeft,{
						duration:0.3,
						autoAlpha:1,
						x:-8
					})
				}


			})
			this.draggie.on('pointerUp', ( event, pointer, moveVector ) => {
				gsap.to(this.circleFill,{
					duration:0.3,
					scale:0.4,
					opacity:0
				})
				gsap.to(this.circleStroke,{
					duration:0.3,
					scale:1,
				})
				gsap.to(this.backgroundElement,{
					// backgroundColor:colorBrown
					backgroundColor:this.colorDragEnd
				});
				gsap.to(this.svgDash,{
					duration:0.3,
					stroke:colorRed
				});
				gsap.to(this.svgBullet,{
					duration:0.3,
					fill:colorRed
				});
				if(!isMobile){
					gsap.to(galleryWrapper,{
						duration:0.3,
						webkitClipPath:'polygon(2% 2%, 98% 2%, 98% 98%, 2% 98%)', clipPath:'polygon(2% 2%, 98% 2%, 98% 98%, 2% 98%)', ease: Power1.easeIn
					});
				}
				else{
					gsap.to(galleryWrapper,{
						duration:0.3,
						webkitClipPath:'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', clipPath:'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', ease: Power1.easeIn
					});
				}

				gsap.to(this.arrowRight,{
					duration:0.3,
					autoAlpha:0,
					x:0
				})
				gsap.to(this.arrowLeft,{
					duration:0.3,
					autoAlpha:0,
					x:0
				})
			})


			this.draggie.on('dragStart', (event, pointer) => {
                if(parseInt(this.currents) > 1){
                    let prevSlide = parseInt(this.currents) - 1;
                    this.control.querySelector('.control__slide[data-order="' + prevSlide + '"]').classList.remove('control__slide--prev');
				}

                if(parseInt(this.currents) < this.quanteSlide){
                    let nextSlide = parseInt(this.currents) + 1;
					this.control.querySelector('.control__slide[data-order="' + nextSlide + '"]').classList.remove('control__slide--next');
				}

				this.control.querySelector('.control__slide[data-order="' + this.currents + '"]').classList.remove('control__slide--active');
			})

			this.draggie.on('dragMove', ( event, pointer, moveVector ) => {

				let tx = this.draggie.position.x;

				// console.log({tx});
				// console.log('drag limit: ', this.dragLimit);

				let translation = Math.round(coeff*tx);
				this.direction = tx;
                if(this.direction < this.prevDirection){
                    this.dir = 'left';
                    this.prevDirection = this.direction;
                }
                if(this.direction > this.prevDirection){
                    this.dir = 'right';
                    this.prevDirection = this.direction;
				}

				//!MOVIMNENTO DELLE DRAG GALLERY
				if(tx > 0 && tx < this.dragLimit){
					gsap.to(galleryContainer,{
						duration:0,
						x:-translation
					});
				}


				[...this.controlSlides].forEach( (controlSlide, indexControSlide) => {
					let ord = parseInt(controlSlide.dataset.order);
					let rect = controlSlide.getBoundingClientRect();

					if(this.dir == 'left'){
						// --- | +++ | +++
						// +++ | +++ | ---
						// ---------------
						//  -  |  +  |  -
						// limit dx --- | +++ | +++		X	limit sx +++ | +++ | ---
						if(tx > controlSlide.offsetLeft && tx < controlSlide.offsetLeft + rect.width*0.75){
							this.currents = ord;
						}
						if(tx <= 0){
							this.currents = 1;
						}
					 }

					 if(this.dir == 'right'){
						 if(tx >= controlSlide.offsetLeft + rect.width/4){
							 this.currents = ord+1;
						 }
						 if(tx >= this.dragLimit){
							this.currents = this.quanteSlide;
						}
					 }

				});

				// console.log(this.currents)

				if(tx < this.dragLimit){
					gsap.to(this.arrowRight,{
						duration:0.3,
						autoAlpha:1,
						x:8
					});
				}
				else{
					gsap.to(this.arrowRight,{
						duration:0.3,
						autoAlpha:0,
						x:0
					});
				}

				if(tx > 0){
					gsap.to(this.arrowLeft,{
						duration:0.3,
						autoAlpha:1,
						x:-8
					})
				}
				else{
					gsap.to(this.arrowLeft,{
						duration:0.3,
						autoAlpha:0,
						x:0
					})
				}


			})

			this.draggie.on('dragEnd', ( event, pointer ) => {
				this.control.querySelector('.control__slide[data-order="' + this.currents + '"]').classList.add('control__slide--active');

				gsap.to(this.dragger,{
					duration:0.5,
					ease:'power1.inOut',
					left:this.control.querySelector('.control__slide[data-order="' + this.currents + '"]').offsetLeft
				})
				gsap.to(galleryContainer,{
					duration:0.5,
					ease:'power1.inOut',
					x:-this.control.querySelector('.control__slide[data-order="' + this.currents + '"]').offsetLeft*coeff
				})
				//!Cambio il link della sezione Must Have in base al prodotto visualizzato
				// if(this.galleryContainer.closest('.sezione__gallerie').querySelector('.txt__cta') !== null){
				// 	this.anchorLinkCta.setAttribute('href',this.arrayMustHaveLinks[this.currents-1])
				// }



			})

		})
	}

}

class SearchForm{
	constructor(form){
		this.form = form;
		this.input = this.form.querySelector('input');
		this.container = this.form.closest('.search-form');
		this.content = this.form.closest('.search-form').querySelector('.content');
		this.contentOffset = this.content.getBoundingClientRect().top;
		this.contentWrapper = this.content.querySelector('.content__wrapper');
		this.formBorder = this.form.querySelector('.form__border');
		this.formBorderSpan = this.formBorder.querySelectorAll('.form__border__span span');
		this.cleanButton = this.form.querySelector('.clean-button');
		this.searchLoader = this.form.querySelector('.search-loader');

		this.header = document.querySelector('header');
		this.links = this.header.querySelectorAll('.link');
		[...this.links].forEach( (link,index) => {
			if(index == 0){
				let anchor = link.querySelector('a');
				this.originalColor = getComputedStyle(anchor).color;
			}

		})

		this.timeout = null;



		this.iconaSearch = document.querySelector('.icona--search');
		// this.iconaSearchWrapperApri = this.iconaSearch.querySelector('.search-header__wrapper.open-search');
		// this.iconaSearchWrapperChiudi = this.iconaSearch.querySelector('.search-header__wrapper.close-search');
		this.searchPage = document.querySelector('.search-page');
		this.closeSearch = this.searchPage.querySelector('.close-search-form');

		this.body = document.querySelector('body');

		this.ctaTxt = 'Vedi';
		if(language !== 'it'){
			this.ctaTxt = 'View';
		}

		//BOOL
		this.isOpening = false;

		this.getString();
		this.setDomSizes();
		this.initEvents();
	}

	initEvents(){

		this.form.addEventListener('submit', e => {
			e.preventDefault();
		})

		this.iconaSearch.addEventListener('click', () => {
			if(this.isOpening) return;
			this.isOpening = true;
			if(this.iconaSearch.classList.contains('opened')){
				this.closeSearchPage();
			}
			else{
				if(document.querySelector('.hamburger__hit-area') !== null && document.querySelector('.hamburger__hit-area').classList.contains('opened')){
					closeMenu().then( () => {
						this.openSearchPage();
						document.querySelector('.hamburger__hit-area').classList.remove('opened');
				})
				}
				else{
					this.openSearchPage();
				}

			}
		})

		this.closeSearch.addEventListener('click',() => {
			this.closeSearchPage();
		})

		this.cleanButton.addEventListener('click',() => {
			this.cleanSearch();
		})
	}

	setDomSizes(){
		gsap.to(this.content,{
			duration:0,
			height: winsize.height - this.contentOffset - 80
		})
	}

	getString(){
		this.input.addEventListener('keyup', () => {
			this.string = this.input.value;
			if(this.string.length > 1){
				clearTimeout(this.timeout);
				this.timeout = setTimeout( () => {
					this.searchAjax();
					gsap.to(this.cleanButton,{
						duration:0.6,
						autoAlpha:1
					})
				},200)
			}
			else{
				gsap.to(this.cleanButton,{
					duration:0.6,
					autoAlpha:1
				})
			}

			// return this.string;
		});
	}

	openSearchPage(){
		this.searchPage.style.display = 'block';
		this.body.style.overflow = 'hidden';
		this.iconaSearch.classList.add('opened');
		this.input.focus();
		setTimeout( () => {
			this.input.focus();
		},200)

		gsap.to(this.formBorderSpan,{
			duration:0.6,
			width:'100%',
			ease:'power2.inOut'
		});
		gsap.to(this.searchPage,{
			duration:0.6,
			autoAlpha:1,
			onComplete:  () => {
				this.isOpening = false;

			}
		});




	}

	closeSearchPage(){
		this.iconaSearch.classList.remove('opened');
		gsap.to(this.formBorderSpan,{
			duration:0.6,
			width:'0%',
			ease:'power2.inOut'
		});
		gsap.to(this.searchPage,{
			duration:0.6,
			autoAlpha:0,
			onComplete: () => {
				this.isOpening = false;
				this.body.style.overflow = 'visible';
				this.searchPage.style.display = 'none';
				this.cleanSearch();
			}
		})


	}

	cleanSearch(){
		this.input.value = '';
		this.contentWrapper.innerHTML = '';
		this.input.focus();
		gsap.to(this.cleanButton,{
			duration:0.3,
			autoAlpha:0
		})
	}


	searchAjax(){
		let formData = new FormData(this.form);
		$.ajax({
            type: 'POST',
            'url': homeUrl+'/opzione-sito/ajax-search',
            data: formData,
            // dataType: 'json',
            contentType: false,
            cache: false,
            processData:false,
			// 'data':{array:array},
			beforeSend: () => {
				gsap.to(this.searchLoader,{
					duration:0.3,
					autoAlpha:1
				})

			},
			success: (result) => {
				gsap.to(this.searchLoader,{
					duration:0.3,
					autoAlpha:0
				})
				if(result !== 'none'){
					let resultObj = JSON.parse(result);
					let item = '';
					let contatore = 0;
					let position = '';
					resultObj.forEach( obj => {
						let labelType = obj.type;
						let labelCta = 'Shop Now';
						if(language === 'it'){
							if(obj.type === 'product'){
								labelType = 'prodotto';
								labelCta = 'Acquista';
							}
						}
						contatore++;
						if( (contatore % 2) == 0 ){
							position = 'right'
						}
						else{
							position = 'left';
						}
						if((contatore % 2) !== 0){
							item += '<div class="row-float clearfix">';
						}
								item += '<div class="link '+obj.type+' '+position+'">';
									item += '<a href="'+ obj.url +'">';
										item += '<div class="link__wrapper">';
											item += '<div class="link__img">';
												item += '<div class="img">';
													item += '<img src="'+obj.image+'">';
												item += '</div>';
											item += '</div>';
											item += '<div class="link__title">';
												item += '<span class="uppercase">'+labelType+'</span>';
												item += '<h3>'+obj.title+'</h3>';
											item += '</div>';
											item += '<div class="cta-rect" data-text-color-hover="#fff" data-text-color-leave="'+colorGold+'">';
												item += '<div class="cta-rect__bg">';
													item += '<span></span>';
												item += '</div>';
												item += '<div class="cta-rect__border"></div>';
												item += '<div class="cta-rect__wrapper">';
													item += '<div class="cta-rect__txt">';
													// if(obj.type == 'news'){
														// item += '<span class="uppercase txt">READ MORE</span>';
													// }
													// else{
														item += '<span class="uppercase txt">'+labelCta+'</span>';
													// }

													item += '</div>';
													item += '<div class="cta-rect__linea">';
														item += '<span></span>';
													item += '</div>';
												item += '</div>';
											item += '</div>';
										item += '</div>';
										item += '<div class="link__border">';
											item += '<span></span>';
										item += '</div>';
									item += '</a>';
								item += '</div>';

						if((contatore % 2) == 0 || (obj.totale % 2 !== 0 && contatore == obj.totale)){
							item += '</div>';
						}

					})


					this.contentWrapper.innerHTML = item;
					new SimpleBar(this.content);
					// console.log(this.form);
					[...this.content.querySelectorAll('.cta-rect')].forEach( cta => {
						new CtaRect(cta);
					})

				}
				else{
					let txt = 'La ricerca non ha prodotto alcun risultato';
					if(language !== 'it'){
						txt = 'Your search produced no results.';
					}
					this.contentWrapper.innerHTML = '<p class="no-result">'+txt+'</p>';

				}


			}
		})
	}

}

class Header{
	constructor(el){
		this.header = el;
		this.headerHeight = this.header.getBoundingClientRect().height;
		this.lastScrollTop = 0;
		this.lastScrollLeft = 0;
		if(this.header.querySelector('.link--sale') !== null){
			this.headerSale = this.header.querySelector('.header__sale')
			this.linkSale = this.header.querySelector('.link--sale');
			this.linkSaleAnchor = this.header.querySelector('.link--sale a');
			this.linkSaleHeight = this.linkSale.getBoundingClientRect().height;
			this.linkSalePaddingBottomToSet = (this.headerHeight - this.linkSaleHeight) / 2;
			// this.linkSaleAnchor.style.paddingBottom = this.linkSalePaddingBottomToSet+'px';
		}




		this.initEvents();
	}

	preventDeafultClickOnSale(){
		this.linkSaleAnchor.style.cursor = 'default';
		this.linkSaleAnchor.addEventListener('click', e => {
			e.preventDefault();
			return
		})
	}

	initEvents(){
		if(!document.querySelector('.horizontal-page') !== null){
			awdScroll.on('scroll', instance => {
				// console.log(instance)
				if(body.classList.contains('header-bloccato')) return;
				this.showHideHeader(instance);
			})
		}
		else{
			// window.addEventListener('mousemove', () => {
			// 	if(body.classList.contains('header-bloccato')) return;
			// 	this.showHideHeaderHorizontal();
			// })

		}
		if(document.querySelector('.page-single-product') !== null){
			// console.log('single')
			this.goBack = document.querySelector('.go-back')
			awdScroll.on('scroll', instance => {
				this.showHideGoBack(instance);
			})
		}


		if(this.header.querySelector('.link--sale') !== null){
			this.preventDeafultClickOnSale();
			this.linkSale.addEventListener('mouseenter', () => {
				this.linkSaleAnchor.style.paddingBottom = this.linkSalePaddingBottomToSet+'px';
				this.linkSaleAnchor.style.paddingRight = this.linkSalePaddingBottomToSet*3+'px';
				this.headerSale.classList.add('opened');
				this.toggleHeaderSale('enter');
			})
			this.linkSale.addEventListener('mouseleave', () => {
				this.headerSale.classList.remove('opened');
				this.linkSaleAnchor.style.paddingBottom = '0px';;
				this.linkSaleAnchor.style.paddingRight = '0px';
				this.toggleHeaderSale('leave');
			})
			this.headerSale.addEventListener('mouseenter', () => {
				this.headerSale.classList.add('opened');
				this.toggleHeaderSale('enter');
			})
			this.headerSale.addEventListener('mouseleave', () => {
				this.headerSale.classList.remove('opened');
				this.toggleHeaderSale('leave');
			})
		}

		// this.header.addEventListener()
	}

	toggleHeaderSale(direction){
		if(direction === 'enter'){
			TweenMax.to(this.headerSale,0.7,{
				// duration:0.7,
				y:'0%',
				ease:'power3.inOut'
			})
		}
		else{
			TweenMax.to(this.headerSale,0.55,{
				// duration:0.55,
				y:'-100%',
				ease:'power2.in'
			})
		}
	}

	showHideHeader(instance){
		//down
		if (instance.direction === 'down' && scrollTop > 100){
			// console.log('down')
			this.header.classList.remove('active');
		}
		//up
		else{
			// console.log('up')
			this.header.classList.add('active');
		}
		// this.lastScrollTop = scrollTop < 0 ? 0 : scrollTop; // For Mobile or negative scrolling

	}

	showHideGoBack(instance){
		//up
		if (instance.direction === 'down' && scrollTop > 20){
			gsap.to(this.goBack,{
				duration:0.4,
				autoAlpha:0
			})
		}
		//down
		else{
			gsap.to(this.goBack,{
				duration:0.4,
				autoAlpha:1
			})
		}
	}

	showHideHeaderHorizontal(){
		// //left
		// if (scrollLeft > this.lastscrollLeft || scrollLeft < 20){
		// 	console.log('left?')
		// 	this.header.classList.remove('active');
		// }
		// //right
		// else{
		// 	// console.log('add')
		// 	console.log('right?')
		// 	this.header.classList.add('active');
		// }
		// this.lastscrollLeft = scrollLeft <= 0 ? 0 : scrollLeft; // For Mobile or negative scrolling

		if(mousePos.y <= this.headerHeight){
			this.header.classList.add('active');
		}
		else{
			this.header.classList.remove('active');
		}
	}


}

class MenuItem{
	constructor(item){
		this.item = item;
		this.itemAnchorLink = this.item.closest('.menu__item');

		this.linkItem = this.item.querySelector('.link__item');
		this.linkItemSpan = this.linkItem .querySelector('span');

		if(this.item.querySelector('.hover-reveal') !== null){
			this.reveal = this.item.querySelector('.hover-reveal');
			this.revealInner = this.item.querySelector('.hover-reveal__inner');
			this.revealImg = this.item.querySelector('.hover-reveal__img');
		}


		this.initEvents();
	}

	initEvents(){

		if(this.itemAnchorLink.classList.contains('current')){
			this.itemAnchorLink.style.cursor = 'default';
			this.itemAnchorLink.addEventListener( 'click', e => {
				e.preventDefault();
				closeMenu();
				body.classList.remove('header-bloccato');
				let hamburgerHitArea = document.querySelector('.hamburger__hit-area');
				hamburgerHitArea.classList.remove('opened');
			})
			return;
		}

        this.positionElement = (ev) => {
            const mousePos = getMousePos(ev);
            const docScrolls = {
                left : document.body.scrollLeft + document.documentElement.scrollLeft,
                top : document.body.scrollTop + document.documentElement.scrollTop
            };
            if(this.item.querySelector('.hover-reveal') !== null){
	            this.reveal.style.top = `${mousePos.y-this.item.getBoundingClientRect().y/1.5}px`;
	            this.reveal.style.left = `${mousePos.x+20-docScrolls.left-(mousePos.x*0.2)}px`;
        	}
        };

		if(!isMobile){
	        this.item.addEventListener('mouseenter', ev => {

	            this.positionElement(ev);
	            this.showImage();

				if(!this.isHover){
					this.isHover = true;
				}

	        } );
	        this.item.addEventListener('mousemove', ev => {
				this.positionElement(ev)
	        });
	        this.item.addEventListener('mouseleave', () => {
	        	this.hideImage();

				this.isHover = false;

	        });
		}



	}
    hideImage() {
        TweenMax.killTweensOf(this.revealInner);
        TweenMax.killTweensOf(this.revealImg);

        this.tl = new TimelineMax({
            onStart: () => {
                TweenMax.set(this.item, {zIndex: 999});
            },
            onComplete: () => {
                TweenMax.set(this.item, {zIndex: ''});
                TweenMax.set(this.reveal, {opacity: 0});
            }
        })
        .add('begin')
        .add(new TweenMax(this.revealInner, 0.6, {
            ease: Expo.easeOut,
            y: '-120%',
            rotation: -5
        }), 'begin')
        .add(new TweenMax(this.revealImg, 0.6, {
            ease: Expo.easeOut,
            y: '120%',
            rotation: 5,
            scale: 1.2
        }), 'begin')
    }
    showImage() {
        TweenMax.killTweensOf(this.revealInner);
        TweenMax.killTweensOf(this.revealImg);

        this.tl = new TimelineMax({
            onStart: () => {
                this.reveal.style.opacity = 1;
                TweenMax.set(this.item, {zIndex: 1000});
            }
        })
        .add('begin')
        .set([this.revealInner, this.revealImg], {transformOrigin: '50% 100%'})
        .add(new TweenMax(this.revealInner, 0.6, {
            ease: Expo.easeOut,
            startAt: {x: '50%', y: '120%', rotation: 50},
            x: '0%',
            y: '0%',
            rotation: 0
        }), 'begin')
        .add(new TweenMax(this.revealImg, 0.6, {
            ease: Expo.easeOut,
            startAt: {x: '-50%', y: '-120%', rotation: 0},
            x: '0%',
            y: '0%',
            rotation: 0
        }), 'begin')
        .add(new TweenMax(this.revealImg, 0.6, {
            ease: Expo.easeOut,
            startAt: {scale: 2},
            scale: 1
        }), 'begin');
    }

}


class SlideShowProduct{
	constructor(slider){
		this.DOM = {slider:slider};
		this.DOM.slideWrapper = this.DOM.slider.querySelector('.slider__wrapper');

		this.arraySlides = [...this.DOM.slider.querySelectorAll('.slide')].map( slide => new SlideProduct(slide));
		this.arrayDots = [...this.DOM.slider.querySelectorAll('.dot')].map( dot => new Dot(dot));

		//Zoom gallery
		this.galleryFull = document.querySelector('.gallery-full');
		this.fullContainer = this.galleryFull.querySelector('.full__container');
		this.closeFullGallery = this.galleryFull.querySelector('.full__close');
		this.openFullGallery = document.querySelector('.open-slide');
		this.fullImage1 = document.getElementById('full-image--1');
		this.fullImageHeight = this.fullImage1.getBoundingClientRect().height;



		this.arraySlidesTotal = this.arraySlides.length;

		//Posizione della slide centrale
		this.center = 0;
		/*BOOL*/
		this.isAnimating = false;
		this.isZooming = false;

		this.controls = {
			prev: this.DOM.slider.querySelector('.control--prev'),
			next: this.DOM.slider.querySelector('.control--next')
		};
		this.prevControlImage = this.controls.prev.querySelector('.esagono__image');
		this.nextControlImage = this.controls.next.querySelector('.esagono__image');

		// if(winsize.width > 768 && !isIpadPro()){
		// 	new customCursor(this.controls.next.querySelector('.control__wrapper'));
		// 	new customCursor(this.controls.prev.querySelector('.control__wrapper'));
		// }


		this.slideRect = this.arraySlides[0].DOM.slide.getBoundingClientRect();
		this.gap = this.slideRect.height*1.2;

		this.initEvents();
		this.setVisibleSlides();
	}



	initEvents(){
		window.addEventListener('resize', () => {
			this.slideRect = this.arraySlides[0].DOM.slide.getBoundingClientRect();
			this.gap = this.slideRect.height;
		})

		//Open zoom gallery
		this.openFullGallery.addEventListener('click', () => {
			let qualeSlide = this.openFullGallery.dataset.slideToOpen;
			if(this.isZooming) return;
			this.isZooming = true;
			this.openZoom(qualeSlide);

		});
		//Close Zoom gallery
		this.closeFullGallery.addEventListener('click', () => {
			if(this.isZooming) return;
			this.isZooming = true;
			this.closeZoom();
		});
		//Chiudo la zoom gallery anche cliccando su un qualsiasi punto
		this.fullContainer.addEventListener('click', () => {
			if(this.isZooming) return;
			this.isZooming = true;
			this.closeZoom();
		});


		this.controls.next.addEventListener('click', () => {
			this.navigate('up');
			// console.log('up');
		});
		this.controls.prev.addEventListener('click', () => {
			this.navigate('down');
			// console.log('down');
		});
		this.arrayDots.forEach( dotClass => {
			dotClass.DOM.dot.addEventListener('click', () => {
				let dot = dotClass.DOM.dot;
				let dotCliccato = dot.dataset.dotNumber;
				let dotCorrente = this.arrayDots[this.center].DOM.dot.dataset.dotNumber
				let diff = Number(dotCliccato) - Number(dotCorrente);
				let direction;
				// console.log(diff)
				if(diff == 0) return;
				if(diff > 0){
					direction = 'up';
				}
				else{
					direction = 'down';
				}
				this.navigate(direction,dotCliccato)
			})
		})
	}

	setVisibleSlides(){
		this.centerSlide = this.arraySlides[this.center];
		this.centerSlide.setCenter();
		this.centerDot = this.arrayDots[this.center];
		this.centerDot.setCenter();

	}

	openZoom(qualeSlide){
		if(awdScroll){

			awdScroll.stop();
		}
		// gsap.to(body,{
		// 	duration:0,
		// 	overflow:'hidden'
		// })
		gsap.to(this.galleryFull,{
			duration:0.6,
			autoAlpha:1,
			onComplete: () => {
				this.isZooming = false;
			}
		})

		gsap.to(this.fullContainer,{
			duration:0,
			// scrollTo:'.full-image[data-full-image="'+qualeSlide+'"]'
			scrollTo:this.fullImageHeight*(qualeSlide-0.75)

		})
	}

	closeZoom(){
		// gsap.to(body,{
		// 	duration:0,
		// 	overflow:'visible'
		// })
		gsap.to(this.galleryFull,{
			duration:0.4,
			autoAlpha:0,
			onComplete: () => {
				this.isZooming = false;
			}
		})
		awdScroll.start();
	}


	navigate(direction,dotCliccato){
		// console.log('dot cliccato: ', dotCliccato);
		if(this.isAnimating) return;
		this.isAnimating = true;
		let upcomingPos;
		if(dotCliccato){
			// console.log('dot cliccato')
			upcomingPos = dotCliccato - 1;
			this.center = dotCliccato - 1;
		}
		else{
			// console.log('dot non cliccato')
			upcomingPos = direction === 'up' ?
					this.center < this.arraySlidesTotal - 1 ? this.center + 1 : Math.abs(this.arraySlidesTotal-1-this.center) :
					this.center >= 1 ? this.center - 1 : Math.abs(this.arraySlidesTotal-1+this.center);
			this.center = direction === 'up' ?
	                this.center < this.arraySlidesTotal-1 ? this.center+1 : 0 :
	                this.center > 0 ? this.center-1 : this.arraySlidesTotal-1;
		}


		this.upcomingSlide = this.arraySlides[upcomingPos];
		this.upcomingDot = this.arrayDots[upcomingPos];

		//Aggiorno il numero di slide sul tasto dello zoom
		this.openFullGallery.dataset.slideToOpen = upcomingPos+1;

		gsap.to(this.upcomingSlide.DOM.slide, {duration:0,y: direction === 'up' ? this.gap : -1*this.gap, autoAlpha:1, 'z-index':51});
		gsap.to(this.upcomingSlide.DOM.slideContainer, {duration:0,rotation: direction === 'up' ? this.upcomingSlide.positiveRotation : this.upcomingSlide.negativeRotation});

		if(direction === 'up'){
			gsap.to(this.nextControlImage,{
				duration: 1.2,
				rotation: '+=45',
			})
		}
		else{
			gsap.to(this.prevControlImage,{
				duration: 1.2,
				rotation: '-=45',
			})
		}

		const movingSlides = [this.upcomingSlide, this.centerSlide];


        let promises = movingSlides.map( slide => {
        	return slide.move(direction, this.gap)
        });

        const movingDots = [this.upcomingDot, this.centerDot];
       	movingDots.forEach( dot => {
        	promises.push(dot.move())
        	// return dot.move()
        });


        Promise.all(promises).then( () => {
        	movingSlides.forEach( slide => slide.reset());
        	movingDots.forEach( dot => dot.reset());
        	this.setVisibleSlides();
			// this.ridimensionaControlli();
        	this.isAnimating = false;
        })

	}
}


class SlideProduct{
	constructor(slide){
		this.DOM = {slide:slide};
		this.DOM.slideWrapper = this.DOM.slide.querySelector('.slide__wrapper');
		this.DOM.slideContainer = this.DOM.slideWrapper.querySelector('.slide__container');
		this.negativeRotation = -15;
		this.positiveRotation = 16;

	}


	setCenter(){
		this.DOM.slide.classList.add('slide--center');
		gsap.to(this.DOM.slide,{
			duration:0,
			autoAlpha:1,
			y:0,
			'z-index': 41
		})
	}

	reset(){
		gsap.to(this.DOM.slide,{
			duration:0,
			autoAlpha:0,
			y:0,
			'z-index':31
		})
		gsap.to(this.DOM.slideWrapper,{
			duration:0,
			transform:'none'
		})
		gsap.to(this.DOM.slideContainer,{
			duration:0,
			transform:'none'
		})


		this.DOM.slide.classList.remove('slide--center');
	}

	move(direction,gap){
		return new Promise( resolve => {
			let duration = 1.2;
			let ty = direction === 'up' ? '+=' + gap*-1 : '+=' + gap;
			let rot = direction === 'up' ? this.negativeRotation : this.positiveRotation;
			// let negativeDirection = direction === 'up' ? 'down' : 'up';
			if(this.DOM.slide.classList.contains('slide--center')){
				gsap.to(this.DOM.slideWrapper,{
					duration:duration,
					y:ty,
					ease:'power2.inOut',
					onComplete: () => {
						resolve()
					}
				})
				gsap.to(this.DOM.slideContainer,{
					duration:duration,
					rotation:rot,
					ease:'power2.inOut',

				})
			}
			else{
				gsap.to(this.DOM.slideWrapper,{
					duration:duration,
					y:ty,
					ease:'power2.inOut',
					onComplete: () => {
						resolve()
					}
				})
				gsap.to(this.DOM.slideContainer,{
					duration:duration,
					rotation:0,
					ease:'power2.inOut'
				})
			}

		})
	}

}

function listingProduct(){

	let products = document.querySelectorAll('.product');
	let duration = 0.3;

	[...products].forEach( product => {
		product.addEventListener('mouseenter', () => {
			productHover(product);
		})
		product.addEventListener('mouseleave', () => {
			productLeave(product);
		})
	})
	function productHover(product){
		let hoverItems = product.querySelectorAll('.hover-item');
		let imageTrequarti = product.querySelector('.image__trequarti');
		let imageLaterale = product.querySelector('.image__laterale');

		TweenMax.to(hoverItems,duration,{
			autoAlpha:1,
			ease:Power1.easeIn
		})
		TweenMax.to(imageTrequarti,duration,{
			autoAlpha:1,
			ease:Power1.easeOut
		})
		TweenMax.to(imageLaterale,duration,{
			autoAlpha:0,
			ease:Power1.easeIn
		})
	}
	function productLeave(product){
		let hoverItems = product.querySelectorAll('.hover-item');
		let imageTrequarti = product.querySelector('.image__trequarti');
		let imageLaterale = product.querySelector('.image__laterale');

		TweenMax.to(hoverItems,duration,{
			autoAlpha:0,
			ease:Power2.easeOut
		})
		TweenMax.to(imageLaterale,duration,{
			autoAlpha:1,
			ease:Power1.easeOut
		})
		TweenMax.to(imageTrequarti,duration,{
			autoAlpha:0,
			ease:Power1.easeIn
		})
	}

}

class ProductPage{
	constructor(productPage){
		this.productPage = productPage;
		this.cta = this.productPage.querySelector('.cta-rect');
		this.addToCartBtn = this.productPage.querySelector('.aggiungi');
		this.addToCartBtnBg = this.productPage.querySelector('.aggiungi__wrapper .cta-rect__bg');
		this.addToCartBtnWrapper = this.productPage.querySelector('.aggiungi__wrapper');
		this.addToCartBtnTxtRelative = this.productPage.querySelector('.aggiungi__wrapper .cta-rect__txt.relative .txt');
		this.addToCartBtnTxtAbsolute = this.productPage.querySelector('.aggiungi__wrapper .cta-rect__txt.absolute .txt');
		
		this.infoSizeBtn = this.productPage.querySelector('.infobtn__wrapper');
		this.infoPopup = document.getElementById('info-popup');

		this.header = document.querySelector('header');
		this.headerBg = this.header.querySelector('.header__bg');

		this.sizesWrapper = this.productPage.querySelector('.sizes');
		this.sizes = this.productPage.querySelectorAll('.size__item');
		this.alertSizeTxt = this.productPage.querySelector('.select-size-alert');

		this.minicart = document.querySelector('.minicart');
		this.minicartWrapper = this.minicart.querySelector('.minicart__wrapper');
		this.minicartBg = this.minicart.querySelector('.minicart__bg');
		this.minicartContainer = this.minicart.querySelector('.minicart__container');

		this.iconaBag = document.querySelector('.icona--bag');
		this.iconaBagQty = this.iconaBag.querySelector('.cart-qty span');

		this.isSizeSelected = false;
		this.isAnimating = false;

		//!Nella wishlist possono esserci i prodotti SOLDOUT
		if(this.addToCartBtn !== null){
			this.initEvents();
		}
	}

	initEvents(){
		if(this.infoSizeBtn){
			this.infoSizeBtn.addEventListener('click', () => {
				this.infoPopupOpen();
			});
			this.infoPopup.querySelectorAll('.form-item').forEach((item) => {
				let input = item.querySelector('.input input');
				let label = item.querySelector('.label')

				input.addEventListener('focus', () => {
					// console.log('focus')
					gsap.to(label,{
						duration:0.6,
						top:'calc(-2rem - 15px)',
						left:0,
						ease:'power2.easeOut'
					})
				})

				input.addEventListener('blur', () => {
					if(input.value === ''){
						gsap.to(label,{
							duration:0.6,
							top:'0%',
							left:'2.5rem',
							ease:'power2.easeOut'
						})
					}
				})
			})
			this.infoPopup.querySelector('.submit').addEventListener('click', () => {
				this.infoFormSend()
			})
			this.infoPopup.querySelector('.bg').addEventListener('click', () => {
				this.infoPopupClose()
			})
			this.infoPopup.querySelector('.wrapper .close').addEventListener('click', () => {
				this.infoPopupClose()
			})
		}

		this.addToCartBtn.addEventListener('click', () => {
			// console.log('click')
			if(!this.isSizeSelected){
				this.alertNoSizeSelected();
				return;
			};
			if(this.isAnimating) return;
			this.isAnimating = true;
			let productId = this.addToCartBtn.dataset.productId;
			let sizeId = this.addToCartBtn.dataset.sizeId;
			let qty = 1;
			this.addToCart(productId, sizeId, qty);
		});

		[...this.sizes].forEach( size => {
			let sizeId = size.dataset.sizeId;
			let sizeName = size.dataset.sizeName;
			size.addEventListener('click', () => {
				if(size.classList.contains('non-disponibile')) return;
				this.isSizeSelected = true;
				gsap.to(this.alertSizeTxt,{
					duration:0.4,
					autoAlpha:0
				});
				[...this.sizes].forEach( siz => {
					siz.classList.remove('selected');
				});
				size.classList.add('selected');
				this.addToCartBtn.dataset.sizeId = sizeId;
				this.addToCartBtn.dataset.sizeName = sizeName;
			})
		});
	}

	infoPopupOpen() {
		gsap.to(this.infoPopup, { duration: 0, autoAlpha: 1})
		gsap.to(this.infoPopup.querySelector('.bg'), { duration: .5, backgroundColor: 'rgba(51, 31, 20, 0.8)', ease:'power1.easeOut'})
		gsap.to(this.infoPopup.querySelector('.wrapper'), { duration: .5, delay: 0.25, autoAlpha: 1, ease:'power1.easeOut'})
	}

	infoPopupClose() {
		gsap.to(this.infoPopup.querySelector('.wrapper'), { duration: .5,  autoAlpha: 0, ease:'power1.easeOut'})
		gsap.to(this.infoPopup.querySelector('.bg'), { duration: .5, delay: 0.25, backgroundColor: 'rgba(51, 31, 20, 0)', ease:'power1.easeOut', onComplete: () => {
			gsap.to(this.infoPopup, { duration: 0, autoAlpha: 0 })
		}})
	}

	infoFormSend() {
		let product = this.infoPopup.querySelector('input[name="infoproduct"]')
		let name = this.infoPopup.querySelector('input[name="infoname"]')
		let surname = this.infoPopup.querySelector('input[name="infosurname"]')
		let mail = this.infoPopup.querySelector('input[name="infomail"]')
		let size = this.infoPopup.querySelector('input[name="infosize"]')

		if(name.value != '' && surname.value != '' && mail.value != '' && validateEmail(mail.value) && size != ''){
			console.log('fasd')
			let formData = new FormData();
			formData.append('product', product.value);
			formData.append('name', name.value);
			formData.append('surname', surname.value);
			formData.append('mail', mail.value);
			formData.append('size', size.value);
			let request = new XMLHttpRequest();
			let url = homeUrl+'/opzione-sito/ajax-submit-info-prodotto-popup';
			request.open('POST', url, true);
			request.onreadystatechange = () => {
				if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
					this.thankyouMessage('infosize').then( () => {
						this.infoPopupClose()
						//console.log('x')
						//window.location.reload();
					})
				}
			};
			request.send(formData);

		}else{
			if(name.value == ''){
				let el = name.closest('.input').closest('.item__wrapper').closest('.form-item').querySelector('.item__error');
				gsap.to(el, { duration:0.6, autoAlpha:1, ease:'power1.easeIn' })
				gsap.to(el, { duration:0.6, y:'-50%', ease:'power1.easeOut' })
				gsap.to(el, { duration:0.6, delay: 2, y:0, autoAlpha: 0, ease:'power1.easeOut' })
			}
			if(surname.value == ''){
				let el = surname.closest('.input').closest('.item__wrapper').closest('.form-item').querySelector('.item__error');
				gsap.to(el, { duration:0.6, autoAlpha:1, ease:'power1.easeIn' })
				gsap.to(el, { duration:0.6, y:'-50%', ease:'power1.easeOut' })
				gsap.to(el, { duration:0.6, delay: 2, y:0, autoAlpha: 0, ease:'power1.easeOut' })
			}
			if(mail.value == ''){
				let el = mail.closest('.input').closest('.item__wrapper').closest('.form-item').querySelector('.item__error.one');
				gsap.to(el, { duration:0.6, autoAlpha:1, ease:'power1.easeIn' })
				gsap.to(el, { duration:0.6, y:'-50%', ease:'power1.easeOut' })
				gsap.to(el, { duration:0.6, delay: 2, y:0, autoAlpha: 0, ease:'power1.easeOut' })
			}else if(!validateEmail(mail.value)){
				let el = mail.closest('.input').closest('.item__wrapper').closest('.form-item').querySelector('.item__error.two');
				gsap.to(el, { duration:0.6, autoAlpha:1, ease:'power1.easeIn' })
				gsap.to(el, { duration:0.6, y:'-50%', ease:'power1.easeOut' })
				gsap.to(el, { duration:0.6, delay: 2, y:0, autoAlpha: 0, ease:'power1.easeOut' })
			}
			if(size.value == ''){
				let el = size.closest('.input').closest('.item__wrapper').closest('.form-item').querySelector('.item__error');
				gsap.to(el, { duration:0.6, autoAlpha:1, ease:'power1.easeIn' })
				gsap.to(el, { duration:0.6, y:'-50%', ease:'power1.easeOut' })
				gsap.to(el, { duration:0.6, delay: 2, y:0, autoAlpha: 0, ease:'power1.easeOut' })
			}
		}
	}

	thankyouMessage(formName){
		let thankyou = document.querySelector('.thankyou-'+formName);
		let thankyouBg = thankyou.querySelector('.thankyou__bg span');
		let thankyouWraper = thankyou.querySelector('.thankyou__wrapper');
		let thankyouTxt = thankyou.querySelectorAll('.thankyou__wrapper p');
		let delay = 8;
		
		if(formName == 'infosize'){
			delay = 2;
		}
		
		return new Promise( (resolve, reject) => {

			gsap.to(thankyou,{
				duration:0,
				autoAlpha:1
			})

			gsap.to(thankyouBg,{
				duration:0.5,
				autoAlpha:1
			})
			gsap.to(thankyouTxt,{
				duration:0.5,
				delay:0.4,
				autoAlpha:1
			})
			gsap.to(thankyouTxt,{
				duration:1,
				delay:delay,
				autoAlpha:0,
				onComplete: () => {
					gsap.to(thankyouBg,{ duration:0.5, autoAlpha:0 })
					gsap.to(thankyou,{ duration:0, autoAlpha: 0 })
					resolve();
				}
			})
		})
	}

	alertNoSizeSelected(){
		gsap.to(this.alertSizeTxt,{
			duration:0.2,
			autoAlpha:1,
			onComplete: () => {
				gsap
					.timeline()
					//body overflow hidden
					.to(this.alertSizeTxt,{
						duration:0.1,
						scale:1.15
					})
					.to(this.alertSizeTxt,{
						duration:0.1,
						scale:1
					})
					.to(this.sizesWrapper,{
						duration:0.1,
						scale:1.15
					})
					.to(this.sizesWrapper,{
						duration:0.1,
						scale:1
					})

			}
		})

	}
	addToCart(productId, sizeId, qty){

		this.beforeAddToCart();

		// gsap.to(this.addToCartBtnWrapper,{
		// 	duration:3,
		// 	motionPath:{
		// 		path:'#svg-path',
		// 		align:'#svg-path'
		// 	}
		// })
		let formData = new FormData();
		formData.append('productId', productId);
		formData.append('sizeId', sizeId);
		formData.append('qty', qty);
		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-add-to-cart';
		request.open('POST', url, true);
		request.onreadystatechange = () => {
			if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {

				let res = request.response;
				this.miniCart();
				let updatedQty = res;
				this.iconaBagQty.innerHTML = updatedQty;
				gsap.to(this.iconaBagQty,{
					duration:0.4,
					autoAlpha:1
				})

				const addToCartEvent = new CustomEvent("addToCart", {
					bubbles: true,
					detail: { product: productId, size: sizeId },
				});

				window.dispatchEvent(addToCartEvent);
			}
		};
		request.send(formData);
	}

	beforeAddToCart(){
			this.header.classList.add('active');
			// console.log('before add')
			if(awdScroll){

				awdScroll.stop();
			}
			if(isMobile){
				body.style.overflow = 'hidden';
			}
			gsap.to(this.headerBg,{
				duration:0.6,
				autoAlpha:1
			});
			// classHeader.toWhite();
			gsap.to(this.minicart,{
				duration:0,
				autoAlpha:1
			})
			gsap.to(this.minicartBg,{
				duration:0.6,
				autoAlpha:1,
				delay:0.3
			})
        	gsap.to(this.cta,{
        		duration:0,
        		cursor:'default'
        	})
        	gsap.to(this.addToCartBtnTxtRelative,{
        		duration:0.4,
        		autoAlpha:0,
        		ease:'power1.out'
        	})
        	gsap.to(this.addToCartBtnTxtAbsolute,{
        		duration:0.6,
        		ease:'power1.out',
        		y:0
        	})
        	gsap.to(this.addToCartBtnTxtAbsolute,{
        		duration:0.6,
        		ease:'power1.in',
        		autoAlpha:1,
        	})
        	gsap.to(this.addToCartBtnBg,{
        		duration:0.6,
        		scaleY:0
        	});
            gsap.to(this.iconaBagQty,{
            	duration:0.4,
            	autoAlpha:0
            })
	}

	miniCart(){

		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-mini-cart';
		request.open('POST', url, true);
		request.onreadystatechange = () => {
            if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				let res = request.response;
				this.minicartContainer.innerHTML = res;
				if(isMobile){
					setMinicartHeightMobile();
				}
				[...document.querySelectorAll('.trigger-cta-rect')].forEach( trigger => {
					// new ctaRect(trigger);
				})
				this.minicart.classList.add('opened');
				this.openMinicart();
				this.minicart.querySelectorAll('.cta-rect').forEach( cta =>{
					new CtaRect(cta)
				})
            }
        };
        request.send();
	}
	openMinicart(){
		gsap.timeline()
			.to(this.minicartContainer,{
				duration:1.2,
				ease:'power2.inOut',
				x:'0%'
			})
			.add( () => {
				this.initAjaxEvents();
				this.resetAddToCartBtn();
				this.isAnimating = false;
			})

	}
	initAjaxEvents(){
		this.closeMinicartBtn = this.minicart.querySelector('.close-minicart');
		this.closeMinicartBtn.addEventListener('click', () => {
			if(this.isAnimating) return
			this.isAnimating = true;
			this.closeMinicart();
		});
		this.minicartBg.addEventListener('click', () => {
			if(this.isAnimating) return
			this.isAnimating = true;
			this.closeMinicart();
		});
		this.contentWrapper = this.minicart.querySelector('.content__wrapper');
		new SimpleBar(this.contentWrapper,{ autoHide: false });

		this.removeItemBtns = this.minicart.querySelectorAll('.info__rimuovi');
		[...this.removeItemBtns].forEach( removeBtn => {
			removeBtn.addEventListener( 'click', () => {
				let key = removeBtn.dataset.key;
				this.removeItemFromCart(key);
			})
		});
		this.totlaPriceContainer = this.minicart.querySelector('.total__price');
	}

	closeMinicart(){
		this.minicart.classList.remove('opened');
		gsap.timeline()
			.to(this.minicartContainer,{
				duration:1.2,
				ease:'power2.inOut',
				x:'100%'
			})
			.to(this.minicartBg,{
				duration:0.6,
				autoAlpha:0
			},'-=0.2')
			.to(this.minicart,{
				duration:0,
				autoAlpha:0
			})
			.add( () => {
				if(awdScroll){
					awdScroll.start();
				}
				if(isMobile){
					body.style.overflow = 'visible';
				}
				this.isAnimating = false;
			})
	}

	removeItemFromCart(key){
		this.berforeRemoveItemFromCart(key);
		let formData = new FormData();
		formData.append('action', 'deleteItem');
		formData.append('key', key);
		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-update-cart';
		request.open('POST', url, true);
		request.onreadystatechange = () => {
			if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				let res = JSON.parse(request.response);
				if(parseInt(res.number) == 0){
					this.closeMinicart();
				}
				this.totlaPriceContainer.querySelector('.price').innerHTML = res.total;
				gsap.to(this.totlaPriceContainer,{
					duration:0.4,
					autoAlpha:1
				})
				this.iconaBagQty.innerHTML = res.number;
				gsap.to(this.iconaBagQty,{
					duration:0.4,
					autoAlpha:1
				})
				const removeFromCartEvent = new CustomEvent("removeFromCart", {
					bubbles: true,
					detail: { element: res.el },
				});

				window.dispatchEvent(removeFromCartEvent);
			}
		};
		request.send(formData);
	}

	berforeRemoveItemFromCart(key){
		let itemDeleted = this.minicart.querySelector('.minicart__item[data-key="' + key + '"]');
		gsap.to(this.totlaPriceContainer,{
			duration:0.4,
			autoAlpha:0
		})
		gsap.to(itemDeleted.querySelector('.minicart__item__wrapper'),{
			duration:0.4,
			autoAlpha:0
		})
		gsap.to(itemDeleted,{
			height:0,
			onComplete: () => {
				itemDeleted.remove();
			}
		});
		gsap.to(this.iconaBagQty,{
			duration:0.4,
			autoAlpha:0
		})
	}

	resetAddToCartBtn(){
		gsap.to(this.cta,{
			duration:0,
			cursor:'pointer'
		})
		gsap.to(this.addToCartBtnTxtRelative,{
			duration:0,
			autoAlpha:1,
		})
		gsap.to(this.addToCartBtnTxtAbsolute,{
			duration:0,
			y:30
		})
		gsap.to(this.addToCartBtnTxtAbsolute,{
			duration:0,
			autoAlpha:0,
		})
		gsap.to(this.addToCartBtnBg,{
			duration:0,
			scaleY:1
		})
	}

}
function setMinicartHeightMobile(){
	let minicartContent = document.querySelector('.minicart__content');
	let minicartContentStyle = getComputedStyle(minicartContent);
	let mincartFooterHieght = document.querySelector('.minicart .content__footer').getBoundingClientRect().height;
	let contentWrapper = document.querySelector('.minicart .content__wrapper');
	let calculatedHeight = winsize.height - mincartFooterHieght;
	gsap.to(contentWrapper,{
		duration:0,
		height:calculatedHeight - parseInt(minicartContentStyle.paddingTop)
	})
}

class FiltriShop{
	constructor(contenitoreFiltri){
		this.contenitoreFiltri = contenitoreFiltri;
		this.filtri = this.contenitoreFiltri.querySelectorAll('.filtro');
		this.applicaFiltriBtn = this.contenitoreFiltri.querySelector('.filters__apply');
		this.resetFiltriBtn = this.contenitoreFiltri.querySelector('.filters__reset');
		this.loader = document.querySelector('.filters__loader');

		this.apriFiltriBtn = document.querySelector('.apri-filtri');

		this.listingContainer = document.querySelector('.listing__container');

		// this.pagineAjax = document.querySelectorAll('.pagina-numero-ajax');

		//BOOL
		this.isAnimating = false;
		this.isFilterOpening = false;
		this.isFiltering = false;

		this.timeOut;

		this.contenitoreFiltri = document.querySelector('.filters');
		this.filtersWrappper = document.querySelector('.filters__wrapper');
		this.filtersOverlay = document.querySelector('.filters__overlay');

		// this.taxonomy = document.querySelector('.page-shop').dataset.taxonomy;
		this.currentCat = document.querySelector('.page-shop').dataset.currentCat;
		// this.main = document.querySelector('.page-shop').dataset.main;

		if(this.apriFiltriBtn !== null){
			this.initEvents();
			this.initDefaultOrder();
			this.paginazioneAjax();
		}

	}
	initEvents(){
		this.apriFiltriBtn.addEventListener('click', () => {
			// console.log(this.isFiltering);
			if(this.isFilterOpening) return;
			if(this.isFiltering) return;
			this.isFilterOpening = true;
			if(this.apriFiltriBtn.classList.contains('opened')){
				this.chiudiFiltri();
				body.classList.remove('header-bloccato');
			}
			else{
				this.apriFiltri();
				body.classList.add('header-bloccato');
			}
		});

		this.filtersOverlay.addEventListener('click', () => {
			if(this.isFilterOpening) return;
			if(this.isFiltering) return;
			this.isFilterOpening = true;
			this.chiudiFiltri();
			body.classList.remove('header-bloccato')
			this.apriFiltriBtn.classList.remove('opened');

		});

		[...this.filtri].forEach( filtro => {
			filtro.addEventListener('click', () => {
				let tipoFiltro = filtro.dataset.tipoFiltro;
				if(tipoFiltro !== 'ordine'){
					if(filtro.classList.contains('selected')){
						this.disevidenziaFiltro(filtro);
					}
					else{
						this.evidenziaFiltro(filtro);
					}
				}
				else{
					this.evidenziaFiltro(filtro);
				}

			})
		})

		this.applicaFiltriBtn.addEventListener('click', () => {
			if(this.isFiltering) return;
			this.isFiltering = true;
			this.chiudiFiltri('applicaFiltriBtn');
			body.classList.remove('header-bloccato');
			this.mostraLoader();
			clearTimeout(this.timeOut);
			this.timeOut = setTimeout( () => {
				this.ajaxFilter();
			},400);


		})

		this.resetFiltriBtn.addEventListener('click', () => {
			if(this.isFiltering) return;
			this.isFiltering = true;
			this.resetFilters();
			this.chiudiFiltri('applicaFiltriBtn');
			body.classList.remove('header-bloccato');
			this.mostraLoader();
			clearTimeout(this.timeOut);
			this.timeOut = setTimeout( () => {
				this.ajaxFilter();
			},400);


		})

	}
	apriFiltri(){
		if(document.querySelector('.categorie-mobile') !== null){
			if(document.querySelector('.categorie-mobile').classList.contains('opened')){
				classSelectCategorieMobile.closeSelect();
				document.querySelector('.categorie-mobile').classList.remove('opened');
			}
		}
		// body.style.overflow = 'hidden';
		if(awdScroll){

			awdScroll.stop();
		}
		gsap.to(this.contenitoreFiltri,{
			duration:0,
			autoAlpha:1
		})
		gsap.to(this.filtersWrappper, {
			duration:0.9,
			x:'0%',
			ease:'power2.inOut',
			onComplete: () => {
				this.isFilterOpening = false
			}
		})
		gsap.to(this.filtersOverlay,{
			duration:0.6,
			autoAlpha:1
		})
		this.apriFiltriBtn.classList.add('opened');


	}
	chiudiFiltri(sourceBtn){
		return new Promise( resolve => {
			gsap.to(this.filtersWrappper, {
				duration:0.9,
				x:'100%',
				ease:'power2.inOut'
			})
			if(sourceBtn !== 'applicaFiltriBtn'){
				gsap.to(this.filtersOverlay,{
					duration:0.9,
					autoAlpha:0,
					ease:'power2.easeIn',
					onComplete: () => {
						this.isFilterOpening = false;
						gsap.to(this.contenitoreFiltri,{
							duration:0,
							autoAlpha:0
						})
						// body.style.overflow = 'visible';
						awdScroll.start();
						resolve();
					}
				})
			}
			this.apriFiltriBtn.classList.remove('opened');
		})

	}
	evidenziaFiltro(filtro){
		let tipoFiltro = filtro.dataset.tipoFiltro;
		if(tipoFiltro == 'taglia'){
			gsap.to(filtro.querySelector('.svg-fill'),{
				duration:0.6,
				autoAlpha:1
			})
			gsap.to(filtro.querySelector('.filtro__txt span'),{
				duration:0.6,
				color:'#fff',
				onComplete: () => {
					// this.isAnimating = false;
				}
			})
		}
		else if(tipoFiltro == 'colore'){
			gsap.to(filtro.querySelector('.svg-stroke'),{
				duration:0.6,
				autoAlpha:1
			})
		}
		else if(tipoFiltro == 'ordine'){
			[...this.contenitoreFiltri.querySelectorAll('.lista-filtri--ordine .filtro')].forEach( filtroOrdine => {
				filtroOrdine.classList.remove('selected');
				let svgCheck = filtroOrdine.querySelector('.svg-check');
				gsap.to(svgCheck, {
					duration:0.4,
					autoAlpha:0
				})
			})
			gsap.to(filtro.querySelector('.svg-check'),{
				duration:0.6,
				autoAlpha:1
			})
		}

		filtro.classList.add('selected')
	}

	disevidenziaFiltro(filtro){
		let tipoFiltro = filtro.dataset.tipoFiltro;
		if(tipoFiltro == 'taglia'){
			gsap.to(filtro.querySelector('.svg-fill'),{
				duration:0.6,
				autoAlpha:0
			})
			gsap.to(filtro.querySelector('.filtro__txt span'),{
				duration:0.6,
				color:colorBrown,
				onComplete: () => {
					// this.isAnimating = false;
				}
			})
		}
		else if(tipoFiltro == 'colore'){
			gsap.to(filtro.querySelector('.svg-stroke'),{
				duration:0.6,
				autoAlpha:0
			})
		}

		filtro.classList.remove('selected');
	}

	mostraLoader(){
		gsap.to(this.loader,{
			duration:0.6,
			autoAlpha:1
		})
	}

	nascondiLoader(){
		gsap.to(this.loader,{
			duration:0.6,
			autoAlpha:0
		})
	}

	resetFilters(){
		[...this.filtri].forEach( filtro => {
			filtro.classList.remove('selected');
			let tipoFiltro = filtro.dataset.tipoFiltro;
			if(tipoFiltro !== 'ordine'){
				this.disevidenziaFiltro(filtro);
			}
			else{
				this.initDefaultOrder();
			}
		})
	}

	initDefaultOrder(){
		let filtriOrdine = [...this.contenitoreFiltri.querySelectorAll('.lista-filtri--ordine .filtro')];
		filtriOrdine.forEach(filtro => {
			filtro.classList.remove('selected','default');
			gsap.to(filtro.querySelector('.svg-check'),{
				duration:0.4,
				autoAlpha:0
			})
		})
		filtriOrdine[0].classList.add('selected','default');
		// let ordineSelezionato = this.contenitoreFiltri.querySelector('.lista-filtri--ordine .selected.filtro');
		gsap.to(filtriOrdine[0].querySelector('.svg-check'),{
			duration:0.4,
			autoAlpha:1
		})
	}
	ajaxFilter(numeroPagina){
		// let filtri = new Array();
		let arrayTaglieIDs = new Array();
		let arrayColoriIDs = new Array();
		let ordine = '';

		[...this.filtri].forEach( filtro => {
			if(filtro.classList.contains('selected')){
				let tipoFiltro = filtro.dataset.tipoFiltro;
				if(tipoFiltro == 'taglia'){
					let idTaglia = filtro.dataset.filtroId;
					arrayTaglieIDs.push(idTaglia);
				}
				if(tipoFiltro == 'colore'){
					let idColore = filtro.dataset.filtroId;
					arrayColoriIDs.push(idColore);
				}
				if(tipoFiltro == 'ordine'){
					ordine = filtro.dataset.ordine;
				}
			}
		})

		// console.log('new')
		// console.log(JSON.stringify(arrayTaglieIDs))

		let formData = new FormData();
		// formData.append('arrayTaglieIDs', arrayTaglieIDs);
		formData.append('arrayTaglieIDs', JSON.stringify(arrayTaglieIDs));
		formData.append('arrayColoriIDs', JSON.stringify(arrayColoriIDs));
		formData.append('ordine', ordine);
		formData.append('currentCat', this.currentCat);

		if(numeroPagina){
			formData.append('pagina', numeroPagina);
		}


		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-filters';
		request.open('POST', url, true);
		request.onreadystatechange = () => {
			if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				// let result = JSON.parse(request.response);
				let result = request.response;
				// console.log(result)
				this.beforeSend(numeroPagina);


				this.listingContainer.innerHTML = result;
	            if(!isMobile){
	            	listingProduct();
				}
				this.nascondiLoader();
				gsap.to(this.filtersOverlay,{
					duration:1.2,
					autoAlpha:0,
					ease:'power2.easeIn',
					onComplete: () => {
						this.isFilterOpening = false;
						gsap.to(this.contenitoreFiltri,{
							duration:0,
							autoAlpha:0
						})
						// body.style.overflow = 'visible';
						awdScroll.start();
						this.isFiltering = false;
					}
				});
				this.paginazioneAjax();
				// inviewItems();
				new WishlistFromListing();
				awdScroll.update();



			}
		};
		request.send(formData);

	}

	beforeSend(numeroPagina){
		gsap.to(document.querySelectorAll('.product .stagger-item-inview'),{
			duration:0.5,
			autoAlpha:0,
			y:50
		})
		if(numeroPagina){
			let target = 0;
			let offset = 0;
			let duration = 1.2;
			let ease = [0.5,0,0.5,1];
			awdScroll.scrollTo(target,offset,duration,ease);
		}
	}

	paginazioneAjax(){
		[...document.querySelectorAll('.pagina-numero-ajax')].forEach( paginaAjax => {
			paginaAjax.addEventListener('click', () => {
				if(paginaAjax.classList.contains('current')) return;
				let numeroPagina = paginaAjax.dataset.pagina;
				this.ajaxFilter(numeroPagina)

			})
		})
	}

}

class Taglie{
	constructor(){
		this.guidaTaglieBtn = document.querySelector('.guida-taglie');
		this.imageTaglie = document.querySelector('.image-taglie');
		this.chiudiTaglie = document.querySelectorAll('.chiudi-taglie-btn');

		this.header = document.querySelector('header');

		this.isAnimating = false;

		this.initEvents();
	}

	initEvents(){
		this.guidaTaglieBtn.addEventListener('click', () => {
			if(this.isAnimating) return;
			this.isAnimating = true;
			this.apriGuidaTaglie();
		});
		[...this.chiudiTaglie].forEach( chiudiBtn => {
			chiudiBtn.addEventListener('click', () => {
				if(this.isAnimating) return;
				this.isAnimating = true;
				this.chiudiGuidaTaglie();
			})
		})

	}

	apriGuidaTaglie(){
		gsap.to(this.imageTaglie,{
			duration:0.6,
			autoAlpha:1,
			onComplete: () => {
				this.isAnimating = false;
			}
		})
		gsap.to(this.header,{
			duration:0.6,
			autoAlpha:0
		})
	}

	chiudiGuidaTaglie(){
		gsap.to(this.imageTaglie,{
			duration:0.6,
			autoAlpha:0,
			onComplete: () => {
				this.isAnimating = false;
			}
		})
		gsap.to(this.header,{
			duration:0.6,
			autoAlpha:1
		})
	}
}

class WishlistFromListing{
	constructor(){
		this.addToWishlistBtns = [...document.querySelectorAll('.add-to-wishlist-btn')];
		this.iconaWishlist = document.querySelector('.icona--wishlist');
		this.iconaWishlistSpan = this.iconaWishlist.querySelector('.wish-qty span');

		this.iconaWishlistMobile = document.querySelector('.icona--wishlist--mobile');
		this.iconaWishlistMobileSpan = this.iconaWishlistMobile.querySelector('.wish-qty span');

		this.isAnimating = false;
		this.isAjaxCalling = false;

		this.initEvents();
	}

	initEvents(){
		this.addToWishlistBtns.forEach( btn => {
			btn.addEventListener('click', () => {
				if(this.isAnimating) return;
				if(this.isAjaxCalling) return;
				this.isAnimating = true;
				this.isAjaxCalling = true;
				let productId = btn.dataset.productId;
				let userId = btn.dataset.userId;
				let messageAdded = btn.closest('.product').querySelector('.wishlist-message .added');
				let messageRemoved = btn.closest('.product').querySelector('.wishlist-message .removed');
				let svgWishlistChecked = btn.querySelector('.svg-wishlist-checked');
				let svgWishlistUnchecked = btn.querySelector('.svg-wishlist-unchecked');
				if(btn.classList.contains('saved')){
					if(btn.classList.contains('product__wishlist')){
						btn.classList.add('hover-item');
					}
					this.changeTitle(btn,'');
					this.wishlistMessage('remove',messageAdded,messageRemoved);
					// this.wishlistIconAnimation('remove',svgWishlistChecked);
					this.removeFromWishlist(productId,userId);
					btn.classList.remove('saved');
				}
				else{
					if(btn.classList.contains('product__wishlist')){
						btn.classList.remove('hover-item');
					}
					this.changeTitle(btn,'saved');
					this.wishlistMessage('add',messageAdded,messageRemoved);
					// this.wishlistIconAnimation('add',svgWishlistChecked);
					this.addToWishlist(productId,userId);
					btn.classList.add('saved');
				}
			})
		})
	}

	wishlistIconAnimation(action,svgWishlistChecked){
		if(action === 'add'){
			gsap.to(svgWishlistChecked,{
				duration:2,
				opacity:1,
				scale:12,
				onComplete: () => {
					gsap.to(svgWishlistChecked,{
						duration:0.2,
						scale:1
					})
				}
			})
		}
		else if(action === 'remove'){
			gsap.to(svgWishlistChecked,{
				duration:0.6,
				opacity:0,
				ease:'power1.easeIn'
			})
			gsap.to(svgWishlistChecked,{
				duration:0.6,
				y:-30,
				ease:'power2.easeOut',
				onComplete: () => {
					gsap.to(svgWishlistChecked,{
						duration:0,
						y:0
					})
				}
			})
		}
	}

	changeTitle(btn,classe){
		let newTitle = '';
		if(classe == 'saved'){
			if(language == 'it'){
				newTitle = 'Rimuovi dalla Wishlist';
			}
			else{
				newTitle = 'Remove from Wishlist';
			}
		}
		else{
			if(language == 'it'){
				newTitle = 'Aggiungi alla Wishlist';
			}
			else{
				newTitle = 'Add to Wishlist';
			}
		}
		btn.setAttribute('title',newTitle);
	}

	wishlistMessage(action,messageAdded,messageRemoved){
		if(action == 'add'){
			gsap.killTweensOf(messageRemoved);
			gsap.to(messageRemoved,{
				duration:0.4,
				autoAlpha:0
			})
			gsap.to(messageAdded,{
				duration:0.4,
				autoAlpha:1
			})
			gsap.to(messageAdded,{
				duration:0.4,
				autoAlpha:0,
				delay:2.2,
				onComplete: () => {
					this.isAnimating = false;
				}
			})
		}
		else{
			gsap.killTweensOf(messageAdded);
			gsap.to(messageAdded,{
				duration:0.4,
				autoAlpha:0
			})
			gsap.to(messageRemoved,{
				duration:0.4,
				autoAlpha:1
			})
			gsap.to(messageRemoved,{
				duration:0.4,
				autoAlpha:0,
				delay:2.2,
				onComplete: () => {
					this.isAnimating = false;
				}
			})
		}
	}

	addToWishlist(productId,userId){

		let formData = new FormData();
		formData.append('productId', productId);
		formData.append('userId', userId);
		formData.append('action', 'add');
		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-add-to-wishlist';
		request.open('POST', url, true);
		request.onreadystatechange = () => {
			if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				let curr = parseInt(this.iconaWishlist.dataset.wishQty);
				curr += 1;
				this.iconaWishlist.dataset.wishQty = curr;
				this.iconaWishlistSpan.innerHTML = curr;
				this.iconaWishlistMobile.dataset.wishQty = curr;
				this.iconaWishlistMobileSpan.innerHTML = curr;
				this.isAjaxCalling = false;

				const addToWishlistEvent = new CustomEvent("addToWishList", {
					bubbles: true,
					detail: { product: productId },
				});

				window.dispatchEvent(addToWishlistEvent);
			}
		};
		request.send(formData);
	}

	removeFromWishlist(productId,userId){
		let formData = new FormData();
		formData.append('productId', productId);
		formData.append('userId', userId);
		formData.append('action', 'remove');
		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-add-to-wishlist';
		request.open('POST', url, true);
		request.onreadystatechange = () => {
            if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
	            let curr = parseInt(this.iconaWishlist.dataset.wishQty);
	            curr -= 1;
	            this.iconaWishlist.dataset.wishQty = curr;
	            this.iconaWishlistSpan.innerHTML = curr;
	            this.iconaWishlistMobile.dataset.wishQty = curr;
	            this.iconaWishlistMobileSpan.innerHTML = curr;
				this.isAjaxCalling = false;
				if(curr == 0){
					this.removeTitle()
				}
            }
        };
		request.send(formData);

	}

	removeTitle(){
		if(document.querySelector('.wishlist__title') !== null){
			gsap.to(document.querySelector('.wishlist__title'),{
				duration:0,
				display:'none'
			})
		}
	}
}



class PageWishlist{
	constructor(wishlist){
		this.wishlist = wishlist;
		this.listWrapper = this.wishlist.querySelector('.list__wrapper');
		this.wishlistItems = this.wishlist.querySelectorAll('.list__item');
		this.iconaWishlist = document.querySelector('.icona--wishlist');
		this.iconaWishlistSpan = this.iconaWishlist.querySelector('.wish-qty span');
		this.iconaWishlistMobile = document.querySelector('.icona--wishlist--mobile');
		this.iconaWishlistMobileSpan = this.iconaWishlistMobile.querySelector('.wish-qty span');
		this.linkShopUomo = this.wishlist.dataset.linkShopUomo;
		this.linkShopDonna = this.wishlist.dataset.linkShopDonna;
		this.initEvents();
	}

	initEvents(){
		if(this.wishlistItems !== null){
			[...this.wishlistItems].forEach( item => {
				let removeBtn = item.querySelector('.item__remove')
				removeBtn.addEventListener('click', () => {
					// if(this.isAnimating) return;
					// this.isAnimating = true;
					let listItem = item;
					let productId = removeBtn.dataset.productId;
					let userId = removeBtn.dataset.userId;
					let requestFrom = 'pagina-wishlist';

					this.removeFromWishlist(listItem,productId,userId);
				})
			})
		}
	}

	removeFromWishlist(listItem,productId,userId){
		let formData = new FormData();
		formData.append('productId', productId);
		formData.append('userId', userId);
		formData.append('action', 'remove');
		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-add-to-wishlist';

		request.open('POST', url, true);
		request.onreadystatechange = () => {
            if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				gsap.to(listItem,{
					duration: 0.5,
					autoAlpha:0
				})

	            let curr = parseInt(this.iconaWishlist.dataset.wishQty);
	            curr -= 1;
	            this.iconaWishlist.dataset.wishQty = curr;
	            this.iconaWishlistSpan.innerHTML = curr;
	            this.iconaWishlistMobile.dataset.wishQty = curr;
	            this.iconaWishlistMobileSpan.innerHTML = curr;
	            if(curr == 0){
					this.removeTitle();
	            	this.printEmptyMessage();

					let target = 0;
					let offset = 0;
					let duration = 800;
					let easing = [0.5, 0.00, 0.5, 1.00];
					awdScroll.scrollTo(target,offset,duration,easing);
	            }
            }
        };
		request.send(formData);

	}
	removeTitle(){
		let title = this.wishlist.closest('.page-wishlist').querySelector('.wishlist__title');
		gsap.to(title,{
			duration:0,
			display:'none'
		})
	}

	printEmptyMessage(){
		let txt = '';
		let msg = 'La tua wishlist è vuota';
		let ctaTxtUomo = 'Shop Men';
		let ctaTxtDonna = 'Shop Women';
		if(language === 'en'){
			msg = 'Your wishlist is empty';
			// ctaTxtUomo = 'Go to Shop'
		}
		txt += '<div class="lista-vuota">';
			txt += '<h2>'+msg+'</h2>';
			txt += '<div class="lista-vuota__ctas">';
				txt += '<a href="'+this.linkShopUomo+'">'
					txt += '<div class="cta-rect" data-text-color-hover="#fff" data-text-color-leave="'+colorGold+'">';
						txt += '<div class="cta-rect__bg">';
							txt += '<span></span>';
						txt += '</div>';
						txt += '<div class="cta-rect__border"></div>';
						txt += '<div class="cta-rect__wrapper">';
							txt += '<div class="cta-rect__txt">';
								txt += '<span class="uppercase txt">'+ctaTxtUomo+'</span>';
							txt += '</div>';
							txt += '<div class="cta-rect__linea">';
								txt += '<span></span>';
							txt += '</div>';
						txt += '</div>';
					txt += '</div>';
				txt += '</a>';
				txt += '<a href="'+this.linkShopDonna+'">'
					txt += '<div class="cta-rect" data-text-color-hover="#fff" data-text-color-leave="'+colorGold+'">';
						txt += '<div class="cta-rect__bg">';
							txt += '<span></span>';
						txt += '</div>';
						txt += '<div class="cta-rect__border"></div>';
						txt += '<div class="cta-rect__wrapper">';
							txt += '<div class="cta-rect__txt">';
								txt += '<span class="uppercase txt">'+ctaTxtDonna+'</span>';
							txt += '</div>';
							txt += '<div class="cta-rect__linea">';
								txt += '<span></span>';
							txt += '</div>';
						txt += '</div>';
					txt += '</div>';
				txt += '</a>';
			txt += '</div>';
		txt += '</div>';

		this.listWrapper.innerHTML = txt;

		[...this.wishlist.querySelectorAll('.cta-rect')].forEach(cta =>{
			new CtaRect(cta);
		})

	}
}

// class HorizontalPage {
//     constructor(){
//         this.cont = document.querySelector('.horizontal-page__wrapper')
//         this.wrapper = this.cont.querySelector('.sections');
//         this.scrl;
//         this.init();
//     }
//     init(){
// 		this.setDimensions();
// 		//!importante il settimeout
// 		setTimeout( () => {
// 			this.horizontalScroll();
// 		},320)
//     }

//     horizontalScroll(){
// 		awdScroll.on('scroll', (instance) => {
// 			this.scrl = instance.scroll.y;
// 			// console.log(this.scrl)
// 			const end = this.wrapper.offsetWidth - hh;
// 			let x = this.scrl;

// 			if(this.scrl >= 0 && this.scrl <= end){
// 				gsap.to(this.wrapper, {duration: 0, x: -x, y: x});

// 			}
// 			if(this.scrl > end){

// 			}
// 		});


//     }
//     setDimensions(){
//         let width2height = this.wrapper.offsetWidth - (ww - hh);
//         this.cont.style.height = width2height + 'px';
// 		this.wrapper.style.height = width2height + 'px';
// 		this.wrapper.dataset.height =  width2height;
//     }
// }

function submitFooterNewsletter(){
	let formFooter = document.querySelector('.form-footer');
	let submit = formFooter.querySelector('.submit');
	let labelEmail = formFooter.querySelector('.email .label');
	let inputEmail = formFooter.querySelector('.input--email input');
	let errorEmail = formFooter.querySelector('.email__error');
	let emailValue = '';

	//Se qualcuno clicca invio impedisco il submit
	formFooter.addEventListener('submit', e => {
		e.preventDefault();
	})

	inputEmail.addEventListener('focus', () => {
		// console.log('focus')
		gsap.to(labelEmail,{
			duration:0.6,
			top:'-100%',
			left:0,
			ease:'power2.easeOut'
		})
	})

	inputEmail.addEventListener('blur', () => {
		emailValue = formFooter.querySelector('.input--email input').value
		if(emailValue === ''){
			gsap.to(labelEmail,{
				duration:0.6,
				top:'0%',
				left:'2.5rem',
				ease:'power2.easeOut'
			})
		}
	})

	submit.addEventListener('click', e => {
		emailValue = formFooter.querySelector('.input--email input').value
		if(!validateEmail(emailValue)){
			gsap.to(errorEmail, {
				duration:0.6,
				autoAlpha:1,
				ease:'power1.easeIn'
			})
			gsap.to(errorEmail, {
				duration:0.6,
				y:0,
				ease:'power1.easeOut'
			})
		}
		else{
			gsap.to(errorEmail, {
				duration:0.6,
				autoAlpha:0,
			})
			formFooter.submit();
		}

	})

}

function submitPopupNewsletter(){
	let formPopup = document.querySelector('.form-popup');
	let submit = formPopup.querySelector('.submit');
	let labelEmail = formPopup.querySelector('.email .label');
	let inputEmail = formPopup.querySelector('.input--email input');
	let errorEmail = formPopup.querySelector('.email__error');
	let emailValue = '';

	//Se qualcuno clicca invio impedisco il submit
	formPopup.addEventListener('submit', e => {
		e.preventDefault();
	})

	inputEmail.addEventListener('focus', () => {
		// console.log('focus')
		gsap.to(labelEmail,{
			duration:0.6,
			top:'-100%',
			left:0,
			ease:'power2.easeOut'
		})
	})

	inputEmail.addEventListener('blur', () => {
		emailValue = formPopup.querySelector('.input--email input').value
		if(emailValue === ''){
			gsap.to(labelEmail,{
				duration:0.6,
				top:'0%',
				left:'2.5rem',
				ease:'power2.easeOut'
			})
		}
	})

	submit.addEventListener('click', e => {
		emailValue = formPopup.querySelector('.input--email input').value
		if(!validateEmail(emailValue)){
			gsap.to(errorEmail, {
				duration:0.6,
				autoAlpha:1,
				ease:'power1.easeIn'
			})
			gsap.to(errorEmail, {
				duration:0.6,
				y:0,
				ease:'power1.easeOut'
			})
		}
		else{
			gsap.to(errorEmail, {
				duration:0.6,
				autoAlpha:0,
			})
			formPopup.submit();
		}

	})

}

class CtaRect{
	constructor(cta){
		this.cta = cta
		this.bg = this.cta.querySelector('.cta-rect__bg');
		this.bgSpan = this.bg.querySelector('span');
		this.ctaTxt = this.cta.querySelector('.cta-rect__txt .txt');
		this.ctaLineaSpan = this.cta.querySelector('.cta-rect__linea span');
		this.textColorHover = '#fff';
		this.textColorLeave = '#fff';

		if(this.cta.dataset.textColorHover){
			this.textColorHover = this.cta.dataset.textColorHover;
			this.textColorLeave = this.cta.dataset.textColorLeave;
		}

		if(!isMobile){

			this.initEvents();
		}


	}

	initEvents(){
		if(!this.cta.classList.contains('main-cta')){
			this.cta.addEventListener('mouseenter', () => {
				this.bgLeftToRight('enter');
				this.changeTextColor('enter');
				this.toggleLinea('enter');
			});

			this.cta.addEventListener('mouseleave', () => {
				this.bgLeftToRight('leave');
				this.changeTextColor('leave');
				this.toggleLinea('leave');
			});
		}
		else{
			this.cta.addEventListener('mouseenter', () => {
				// this.toggleBg('enter');
				this.bgRightToLeft('enter');
				this.changeTextColor('enter');
				this.toggleLinea('enter');
			});

			this.cta.addEventListener('mouseleave', () => {
				// this.toggleBg('leave');
				this.bgRightToLeft('leave');
				this.changeTextColor('leave');
				this.toggleLinea('leave');
			});
		}

	}

	toggleLinea(direction){
		if(direction === 'enter'){
			gsap.to(this.ctaLineaSpan,{
				duration:0.6,
				width:'0%',
				ease:'power2.out'
			})
		}
		else if(direction === 'leave'){
			gsap.to(this.ctaLineaSpan,{
				duration:0.6,
				width:'100%',
				ease:'power2.out'
			})
		}
	}

	// Provata per la main cta
	// toggleBg(direction){
	// 	if(direction === 'enter'){
	// 		gsap.to(this.bgSpan,{
	// 			duration:0.6,
	// 			autoAlpha:0
	// 		})
	// 	}
	// 	else if(direction === 'leave'){
	// 		gsap.to(this.bgSpan,{
	// 			duration:0.6,
	// 			autoAlpha:1
	// 		})
	// 	}
	// }

	changeTextColor(direction){
		if(direction === 'enter'){
			gsap.to(this.ctaTxt,{
				duration:0.6,
				color:this.textColorHover
			})
		}
		else if(direction === 'leave'){
			gsap.to(this.ctaTxt,{
				duration:0.6,
				color:this.textColorLeave
			})
		}
	}


	//Per la main cta, quella che parte con bg fill
	bgRightToLeft(direction){
		if(direction === 'enter'){
			TweenMax.to(this.bgSpan,0.6,{
				// duration:0.6,
				width:'0%',
				ease:'power2.out'
			})
		}
		else if(direction === 'leave'){
			TweenMax.to(this.bgSpan,0.6,{
				// duration:0.6,
				width:'100%',
				ease:'power2.out'
			})
		}

	}


	bgLeftToRight(direction){
		if(direction === 'enter'){
			gsap.to(this.bgSpan,{
				duration:0.6,
				width:'100%',
				ease:'power2.out'
			})
		}
		else if(direction === 'leave'){
			gsap.to(this.bgSpan,{
				duration:0.6,
				width:'0%',
				ease:'power2.out'
			})
		}

	}
}

class InputText{
	constructor(input){
		this.input = input;
		if(!this.input.classList.contains('input--textarea')){
			this.inputField = this.input.querySelector('input');
		}
		else{
			this.inputField = this.input.querySelector('textarea');
		}
		if(this.input.classList.contains('input--password')){
			this.viewPasswordBtn = this.input.querySelector('.view-password-btn');
		}
		if(this.input.closest('.error-check-container') !== null){
			this.errorCheckContainer = this.input.closest('.error-check-container');
			this.labelError = this.errorCheckContainer.querySelector('.label__error');
		}

		// this.form = this.input.closest('form');
		// this.isHorizontal = document.querySelector('.horizontal-page') !== null ?  true : false;
		// if(this.isHorizontal){
		// 	this.horizontalOffset = this.form.getBoundingClientRect().x;
		// 	console.log(this.horizontalOffset - scrollTop);
		// 	awdScroll.on('scroll', instance => {
		// 		console.log(this.horizontalOffset - scrollTop);
		// 	})
		// }


		this.isInputEmail = false;

		if(this.input.classList.contains('input--email')){
			this.isInputEmail = true;
		}

		this.initEvents();
	}

	initEvents(){

		this.inputField.addEventListener('focus', e => {
			// awdScroll.stop();
			// awdScroll.start();
			gsap.to(this.input,0.4,{
				// borderColor:colorOrange,
				'border-top-width':3,
				'border-right-width':3,
				'border-bottom-width':3,
				'border-left-width':3
			});
		});

		this.inputField.addEventListener('blur', e => {
			// awdScroll.stop();
			// awdScroll.start();
			gsap.to(this.input,0.4,{
				'border-top-width':1,
				'border-right-width':1,
				'border-bottom-width':1,
				'border-left-width':1
			});
			this.checkStatus();
		});

		//Alcuni campi potrebbero essere precompilati, quindi chekko anche all'init
		if(this.inputField.getAttribute('type') === 'email' && document.querySelector('.page-contatti') !== null){
			let thankyou = document.querySelector('.thankyou-contatti');
			thankyou.querySelector('.js-email').innerHTML = this.inputField.value;
		}
		if(this.inputField.classList.contains('email-reso')){
			let thankyou = document.querySelector('.thankyou-reso');
			thankyou.querySelector('.js-email').innerHTML = this.inputField.value;
		}
		if(this.inputField.classList.contains('email-assistenza')){
			let thankyou = document.querySelector('.thankyou-contatti');
			thankyou.querySelector('.js-email').innerHTML = this.inputField.value;
		}


		this.inputField.addEventListener('keyup', () => {
			if(this.input.closest('.error-check-container') !== null && this.errorCheckContainer.classList.contains('errore-attivo')){
			// if(this.errorCheckContainer.classList.contains('errore-attivo')){
				this.checkStatus();
			}
			if(this.inputField.getAttribute('type') === 'email' && document.querySelector('.page-contatti') !== null){
				let thankyou = document.querySelector('.thankyou-contatti');
				thankyou.querySelector('.js-email').innerHTML = this.inputField.value;
			}
			if(this.inputField.classList.contains('email-reso')){
				let thankyou = document.querySelector('.thankyou-reso');
				thankyou.querySelector('.js-email').innerHTML = this.inputField.value;
			}
		});

		if(this.input.classList.contains('input--password')){
			this.viewPasswordBtn.addEventListener('click', () => {
				this.toggleViewPassword();
			})
		}
	}

	toggleViewPassword(){
		// console.log('click')
		if (this.inputField.type === "password") {
			this.inputField.type = "text";
		} else {
			this.inputField.type = "password";
		}
	}

	checkStatus(){
		if(this.input.classList.contains('campo-obbligatorio')){
			let inputValue = this.inputField.value;
			let errorValue = '';
			//campo txt
			if(!this.isInputEmail){
				if(inputValue == ''){
					this.showError();
					errorValue = 'si';
				}
				else{
					this.hideError();
					errorValue = 'no';
				}
			}
			//campo email
			else{
				if(!validateEmail(inputValue)){
					this.showError();
					errorValue = 'si';
				}
				else{
					this.hideError();
					errorValue = 'no';
				}

			}
			return errorValue;
		}
	}

	showError(){
		gsap.to(this.labelError,0.4,{
			autoAlpha:1
		});
		// TweenMax.to(this.input,0.4,{
		// 	borderColor:'#fff'
		// });
		this.errorCheckContainer.classList.add('errore-attivo');
	}

	hideError(){
		TweenMax.to(this.labelError,0.4,{
			autoAlpha:0
		});
		// TweenMax.to(this.input,0.4,{
		// 	borderColor:colorGold
		// });
		this.errorCheckContainer.classList.remove('errore-attivo');
	}
}

class InputSelect{
	constructor(select){
		this.select = select;
		this.selectHeader = this.select.querySelector('.select__header');
		this.selectHeaderTxt = this.selectHeader.querySelector('p');
		this.selectBody = this.select.querySelector('.select__fake');
		this.selectBodyList = this.selectBody.querySelector('.fake__list');
		this.selectBodyListHeight = this.selectBodyList.getBoundingClientRect().height;
		this.fakeSelect = this.select.querySelector('select.select__real');

		if(this.select.closest('.error-check-container') !== null){
			this.errorCheckContainer = this.select.closest('.error-check-container');
			this.labelError = this.errorCheckContainer.querySelector('.label__error');
		}

		this.options = this.select.querySelectorAll('.fake__option');

		this.initEvents();
	}

	initEvents(){
		this.selectHeader.addEventListener('click', () => {
			this.toggleSelect();
		});

		[...this.options].forEach( option => {
			let optionTxt = option.querySelector('.option__txt');
			optionTxt.addEventListener('click', () => {
				if(option.classList.contains('selected') || this.isAnimating) return;
				this.isAnimating = true;
				this.resetSelect();

				let dataOption = option.dataset.option;
				this.select.dataset.opzioneSelezionata = dataOption;
				// imposto il valore della vera select
				this.fakeSelect.value = dataOption;

				gsap.to(this.selectHeaderTxt,0.4,{
					autoAlpha:0,
					onComplete: () => {
						this.select.classList.add('scelta-effettuata'); /*serve per il css*/
						option.classList.add('selected');
						this.selectHeaderTxt.innerHTML = optionTxt.innerHTML;
					}
				});
				gsap.to(this.selectHeaderTxt,0.4,{
					autoAlpha:1,
					delay:0.4,
					onComplete: () => {
						this.isAnimating = false;
						this.checkStatus();
					}
				});
				this.closeSelect();
			})
			optionTxt.addEventListener('mouseenter', () => {
				if(option.classList.contains('selected')) return;
				gsap.to(option,0.4,{
					backgroundColor:colorGold
				});
				// gsap.to(optionTxt,0.4,{
				// 	color:colorRed
				// });
			})

			optionTxt.addEventListener('mouseleave', () => {
				if(option.classList.contains('selected')) return;
				gsap.to(option,0.4,{
					backgroundColor:'transparent'
				});
				// gsap.to(optionTxt,0.4,{
				// 	color:colorBrown
				// });
			})
		})

		//chiudo la select quando clicco in giro per il document
		document.addEventListener('click', e => {
			if(!e.target.classList.contains('target-dont-close') && this.select.classList.contains('open')){
				this.closeSelect();
			}
		});

	}

	checkStatus(){
		if(this.select.classList.contains('campo-obbligatorio')){
			let opzioneSelezionata = this.select.dataset.opzioneSelezionata;
			let errorValue = '';
			if(opzioneSelezionata == ''){
				this.showError();
				errorValue = 'si';
			}
			else{
				this.hideError();
				errorValue = 'no';
			}
			return errorValue;
		}
	}

	showError(){
		TweenMax.to(this.labelError,0.4,{
			autoAlpha:1
		});
		TweenMax.to(this.selectHeader,0.4,{
			borderColor:'#fff'
		});
		this.errorCheckContainer.classList.add('errore-attivo');
	}

	hideError(){
		TweenMax.to(this.labelError,0.4,{
			autoAlpha:0
		});
		TweenMax.to(this.selectHeader,0.4,{
			borderColor:colorGold
		});
		this.errorCheckContainer.classList.remove('errore-attivo');
	}

	resetSelect(){
		[...this.options].forEach( option => {
			option.classList.remove('selected');
		})
	}

	toggleSelect(){
		if(this.select.classList.contains('open')){
			this.closeSelect();
		}
		else{
			this.openSelect();
		}
	}
	closeSelect(){
		gsap.to(this.selectBody,0.6,{
			height:0
		});
		this.select.classList.remove('open');
	}

	openSelect(){
		gsap.to(this.selectBody,0.6,{
			height:this.selectBodyListHeight
		});
		this.select.classList.add('open');
	}
}

class Checkbox{
	constructor(cb){
		this.cb = cb;

		this.unchecked = this.cb.querySelector('.unchecked');
		this.svgUnchecked = this.cb.querySelector('.svg-unchecked');
		this.checked = this.cb.querySelector('.checked');
		this.svgChecked = this.cb.querySelector('.svg-checked');
		this.txt = this.cb.querySelector('.checkbox__txt');
		this.txtSpan = this.txt.querySelector('span');
		if(this.txt.querySelector('a') !== null){
			this.txtAnchor = this.txt.querySelector('a');
		}

		this.txtOriginalColor = getComputedStyle(this.txtSpan).color;

		this.initEvents();
	}

	initEvents(){
		this.cb.addEventListener('click', () => {
			this.changeCheckboxStatus();
		})
	}

	changeCheckboxStatus(){
		this.dataCheckboxStatus = this.cb.dataset.checkboxstatus;
		if(this.dataCheckboxStatus == 'checked'){
			gsap.to(this.checked,0.6,{
				autoAlpha:0
			});
			this.cb.dataset.checkboxstatus = 'unchecked';
		}
		else{
			gsap.to(this.checked,0.6,{
				autoAlpha:1
			});
			gsap.to(this.svgUnchecked,0.6,{
				stroke:colorGold
			});
			gsap.to(this.txtSpan,0.6,{
				color:this.txtOriginalColor
			});
			if(this.txt.querySelector('a') !== null){
				TweenMax.to(this.txtAnchor,0.6,{
					color:colorGold
				});
			}
			this.cb.dataset.checkboxstatus = 'checked';
		}
	}

	checkStatus(){
		if(this.cb.classList.contains('campo-obbligatorio')){
			this.dataCheckboxStatus = this.cb.dataset.checkboxstatus;
			let errorValue = '';
			if(this.dataCheckboxStatus == 'unchecked'){
				gsap.to(this.svgUnchecked,0.6,{
					stroke:'#f00'
				});
				gsap.to(this.txtSpan,0.6,{
					color:'#f00'
				});
				if(this.txt.querySelector('a') !== null){
					gsap.to(this.txtAnchor,0.6,{
						color:'#f00'
					});
				}
				errorValue = 'si';

			}
			else{
				errorValue = 'no';
			}
			return errorValue;
		}
	}


}

class Form{
	constructor(form){
		this.form = form;
		this.formName = this.form.dataset.formname;
		// this.siteUrl = document.getElementById('siteUrl').getAttribute('data-siteurl');


		//BOOL
		this.isWaiting = false;
		this.isAnimating = false;

		this.submit = this.form.querySelector('.submit');
		this.submitTxt = this.submit.querySelector('.txt');
		this.ctaTxt = this.submitTxt.innerHTML;

		if(this.form.querySelector('.errore-generico') !== null){
			this.erroreGenerico = this.form.querySelector('.errore-generico');
			this.erroreGenericoTxt = this.erroreGenerico.querySelector('.txt');
		}

		this.checkboxesObbligatorie = this.form.querySelectorAll('.checkbox.campo-obbligatorio');
		this.arrayCheckoxesObbligatorie = [...this.checkboxesObbligatorie].map( cb => new Checkbox(cb));

		if(this.form.querySelectorAll('.input') !== null){
			this.arrayInputs = [...this.form.querySelectorAll('.input')].map( input => new InputText(input));
		}

		if(this.form.querySelectorAll('.select') !== null){
			this.arraySelects = [...this.form.querySelectorAll('.select')].map( select => new InputSelect(select));
		}

		this.setRowZindex();
		this.initEvents();

	}

	initEvents(){
		this.form.addEventListener('submit', e => {
			e.preventDefault();
		})

		this.submit.addEventListener('click', () => {
			if(this.isWaiting) return;
			this.startWaiting();
			this.checkErrors();

		})
	}

	startWaiting(){
		let txt = 'ATTENDERE...';
		if(language !== 'it'){
			txt = 'PLEASE WAIT...';
		}
		this.isWaiting = true;
		this.submit.classList.add('is-waiting');
		this.submitTxt.innerHTML = txt;
		gsap.to(this.submit,{
			duration:0,
			cursor:'default'
		});
		gsap.to(this.submit,{
			duration:0.4,
			autoAlpha:0.3
		})
	}

	stopWaiting(){
		this.isWaiting = false;
		this.submit.classList.remove('is-waiting');
		this.submitTxt.innerHTML = this.ctaTxt;
		gsap.to(this.submit,{
			duration:0,
			cursor:'pointer'
		});
		gsap.to(this.submit,{
			duration:0.4,
			autoAlpha:1
		})

	}

	//le select devono coprire gli altri field quando le apro
	setRowZindex(){
		let arrayFormRows = [...this.form.querySelectorAll('.form__row')];
		let quanteRow = arrayFormRows.length;
		arrayFormRows.forEach( (row, index) => {
			TweenMax.set(row,{
				'z-index': quanteRow - index
			})
		})
	}

	checkErrors(){
		this.arrayErrors = [];

		this.arrayCheckoxesObbligatorie.forEach( checkboxClass => {
			let errorValue = checkboxClass.checkStatus();
			if(errorValue === 'si'){
				this.arrayErrors.push(errorValue);
			}
		});


		this.arrayInputs.forEach( inputCLass => {
			if(inputCLass.input.classList.contains('campo-obbligatorio')){
				let errorValue = inputCLass.checkStatus();
				if(errorValue === 'si'){
					this.arrayErrors.push(errorValue);
				}
			}
		});
		this.arraySelects.forEach( selectCLass => {
			if(selectCLass.select.classList.contains('campo-obbligatorio')){
				let errorValue = selectCLass.checkStatus();
				if(errorValue === 'si'){
					this.arrayErrors.push(errorValue);
				}
			}
		});

		//se ci sono errori
		if(this.arrayErrors.length > 0){
			if(this.form.querySelector('.errore-generico') !== null){
				TweenMax.to(this.erroreGenericoTxt,0.6,{
					autoAlpha:1
				});
			}
			// this.scrollToError();
			this.stopWaiting()
			//this.submitForm(this.formName)	//commentare o cancellare quando si va online

		}
		//se NON ci sono errori
		else{
			// console.log('non ci sono errori')
			if(this.form.querySelector('.errore-generico') !== null){
				TweenMax.to(this.erroreGenericoTxt,0.6,{
					autoAlpha:0
				});
			}
			this.submitForm(this.formName)
		}
	}

	submitForm(formName){
		if(formName === 'newsletter'){
			this.inviaFormNewsletter();
		}
		else if(formName === 'contatti'){
			this.inviaFormContatti();
		}
		else if(formName === 'login'){
			this.inviaFormLogin();
		}
		else if(formName === 'registrazione'){
			this.inviaFormRegistrazione();
		}
		else if(formName === 'reso'){
			this.inviaFormReso();
		}
		else if(formName === 'assistenza'){
			this.inviaFormAssistenza();
		}
	}

	inviaFormAssistenza(){
		// console.log('invia form')
		let formData = new FormData(this.form);
		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-submit-servizio-clienti';
		request.open('POST', url, true);
		request.onreadystatechange = () => {
            if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				let res = JSON.parse(request.response);
				// console.log(res)
				this.thankyouMessage('contatti').then( () => {
					window.location.reload();
			   	})

            }
        };
		request.send(formData);

	}

	inviaFormReso(){
		let formData = new FormData(this.form);
		$.ajax({
			'method':'POST',
			'url': homeUrl+'/opzione-sito/ajax-submit-richiesta-reso',
            data: formData,
            // dataType: 'json',
            contentType: false,
            cache: false,
            processData:false,
			success: (result) => {
				if(result === 'controllo-non-superato'){
					TweenMax.to(this.erroreGenericoTxt,0.6,{
						autoAlpha:1
					});
					this.stopWaiting();
				}
				else{
					this.thankyouMessage('reso').then( () => {
						 window.location.reload();
					})

				}

			}
		})
	}

	inviaFormContatti(){
		// console.log('invia form')
		let formData = new FormData(this.form);
		let request = new XMLHttpRequest();
		let url = homeUrl+'/opzione-sito/ajax-submit-contatti';
		request.open('POST', url, true);
		request.onreadystatechange = () => {
            if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				let res = JSON.parse(request.response);
				// console.log(res)
				this.thankyouMessage('contatti').then( () => {
					window.location.reload();
			   	})

            }
        };
		request.send(formData);

	}

	inviaFormNewsletter(){
        //Da Agosto/Settembre 2023 le chiamate API di 4DEm vengono bloccate dal CORS, per cui passiamo alle chiamate API con PHP che bypassano questo problema		
		// let body = {
		// 	"email_address": this.form.querySelector('input[name="EMAIL"]').value,
		// 	"subscription": {
		// 		"ip": document.getElementById('newsletter-ip').value.toUpperCase(),
		// 		"status": "Subscribed"
		// 	},
		// 	"triggers": {
		// 		"automation": true,
		// 		"behaviors": false,
		// 		"send_confirmation_email": true
		// 	},
		// 	"update_if_duplicate": true,
		// 	"custom_fields": [
		// 		{
		// 			"id": 280538, //Nome
		// 			"value": this.form.querySelector('input[name="NAME"]').value
		// 		},
		// 		{
		// 			"id": 280539, //Cognome
		// 			"value": this.form.querySelector('input[name="SURNAME"]').value
		// 		},
		// 		{
		// 			"id": 287499, //Preferenze di acquisto
		// 			"value": this.form.querySelector('select[name="INTERESSE"]').value
		// 		}
		// 	]
		// }
		// this.fetch4DEMApi(body)
		let APIKey = "3883-253b-9c1d-7c52-bdf5-9d4f-c5b3-d1d0"
		let lista = 88341
		let emailAddress = this.form.querySelector('input[name="EMAIL"]').value
		let nome = this.form.querySelector('input[name="NAME"]').value
		let cognome = this.form.querySelector('input[name="SURNAME"]').value
		let interesse = this.form.querySelector('select[name="INTERESSE"]').value
		this.fetch4DEMApi(APIKey, lista, emailAddress, nome, cognome, interesse)

	}
	fetch4DEMApi(APIKey, lista, emailAddress, nome, cognome, interesse){
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        formData.append('action', 'subscribe')
        formData.append('APIKey', APIKey)
        formData.append('lista', lista)
        formData.append('emailAddress', emailAddress)
        formData.append('nome', nome)
        formData.append('cognome', cognome)
        formData.append('interesse', interesse)
        let url = document.getElementById('uri').value + '/AJAX/iscrizione-newsletter.php'
		console.log(url)
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // let res = JSON.parse(request.response)
                // console.log(res.token)
                // console.log(request.response)


				this.thankyouMessage('newsletter').then( () => {
					window.location.reload();
				})

            }
        }
        request.send(formData)

	}
	//Da Agosto/Settembre 2023 le chiamate API di 4DEm vengono bloccate dal CORS, per cui passiamo alle chiamate API con PHP che bypassano questo problema
	// fetch4DEMApi(body){
	// 	let that = this;

	// 	axios.post('https://api.4dem.it/api/authenticate', {
	// 		APIKey: "3883-253b-9c1d-7c52-bdf5-9d4f-c5b3-d1d0"
	// 	})
	// 	.then(function (res) {
	// 		axios.post('https://api.4dem.it/api/recipients/88341/subscribe?token=' + res.data.token, body)
	// 		.then(function (response) {
	// 			that.thankyouMessage('newsletter').then( () => {
	// 				window.location.reload();
	// 			})
	// 		})
	// 		.catch(function (error) {
	// 			//Logica per controllo di utente gia esistente ma bisogna passare nel body "update_if_duplicate": false
	// 		});
	// 		//console.log(response);
	// 	})
	// 	.catch(function (error) {
	// 		//gsap.to(that.newsletterLoad, { duration: 0.5, autoAlpha: 0, ease: 'cubic-1'})
	// 		console.log('error', error);
	// 	});
	// }

	inviaFormLogin(){
		let formData = new FormData(this.form);
		let redirectLink = document.querySelector('.page-login').dataset.redirect;
		$.ajax({
			'method':'POST',
			'url': homeUrl+'/opzione-sito/ajax-submit-login',
            data: formData,
            // dataType: 'json',
            contentType: false,
            cache: false,
            processData:false,
			success: (result) => {
				// console.log(result);
				if(result === 'error'){
					TweenMax.to(this.erroreGenericoTxt,0.6,{
						autoAlpha:1
					});
					this.stopWaiting();
				}
				else{
					// this.stopWaiting();
					this.thankyouMessage('login').then( () => {
						 window.location.href = redirectLink;
					})
				}
			}
		})
	}
	inviaFormRegistrazione(){
		let formData = new FormData(this.form);
		let redirectLink = document.querySelector('.page-login').dataset.redirect;
		$.ajax({
			'method':'POST',
			'url': homeUrl+'/opzione-sito/ajax-submit-registrazione',
            data: formData,
            contentType: false,
            cache: false,
            processData:false,
			success: (result) => {
				// console.log(result);
				if(result === 'error'){
					TweenMax.to(this.erroreGenericoTxt,0.6,{
						autoAlpha:1
					});
					this.stopWaiting();
				}
				else{
					this.thankyouMessage('registrazione').then( () => {
						 window.location.href = redirectLink;
					})

				}

			}
		})
	}

	thankyouMessage(formName){
		let thankyou = document.querySelector('.thankyou-'+formName);
		let thankyouBg = thankyou.querySelector('.thankyou__bg span');
		let thankyouWraper = thankyou.querySelector('.thankyou__wrapper');
		let thankyouTxt = thankyou.querySelectorAll('.thankyou__wrapper p');
		let delay = 8;
		if(this.formName == 'login'){
			delay = 2;
		}
		if(this.formName == 'registrazione'){
			delay = 2;
		}
		if(this.formName == 'newsletter'){
			delay = 4;
		}
		return new Promise( (resolve, reject) => {

			gsap.to(thankyou,{
				duration:0,
				autoAlpha:1
			})

			gsap.to(thankyouBg,{
				duration:0.5,
				autoAlpha:1
			})
			gsap.to(thankyouTxt,{
				duration:0.5,
				delay:0.4,
				autoAlpha:1
			})
			gsap.to(thankyouTxt,{
				duration:1,
				delay:delay,
				autoAlpha:0,
				onComplete: () => {
					resolve();
				}
			})
		})
	}
}
// temporary()
// function temporary(){
// 	let items = document.querySelectorAll('.menu__item');
// 	items.forEach( item => {
// 		item.addEventListener('click', e =>{
// 			e.preventDefault();
// 		})
// 	})
// }

function goBack(){
	let goBackBtns = document.querySelectorAll('.go-back');
	goBackBtns.forEach( btn => {
		btn.addEventListener( 'click', () => {
			window.history.back();
		})

	})
}

function pageLoginResitrazione(){
	let form;
	let wrapper;
	if(document.querySelector('.login__form') !== null){
		form = document.querySelector('.login__form');
		wrapper = document.querySelector('.login__wrapper');
	}
	else{
		form = document.querySelector('.register__form');
		wrapper = document.querySelector('.register__wrapper');
	}

	let formH = form.getBoundingClientRect().height;
	let headerH = document.querySelector('header').getBoundingClientRect().height;

	if(formH < hh - headerH){
		wrapper.style.position = 'absolute';
	}
	else{
		wrapper.style.position = 'relative';
	}


}

class FullCanvas{
	constructor(){
		// console.log('init canvas')
		this.canvas = document.getElementById('canvas');
		this.ctx = this.canvas.getContext('2d');
		this.counter = 0;

		if(!isMobile){
			/*DESKTOP*/
			this.imageRatio = 1240/2202;
			let imageFull = document.getElementById('image-full');
			let imageFullSrc = imageFull.getAttribute('src');
			this.imageFull = new Image();
			this.imageFull.src = imageFullSrc;
			let maskFull = document.getElementById('mask-full');
			let maskFullSrc = maskFull.getAttribute('src');
			this.maskFull = new Image();
			this.maskFull.src = maskFullSrc;
		}
		else{
			/*MOBILE*/
			this.imageRatio = 1800/1500;
			let imageFull = document.getElementById('image-full-mobile');
			let imageFullSrc = imageFull.getAttribute('src');
			this.imageFull = new Image();
			this.imageFull.src = imageFullSrc;
			let maskFull = document.getElementById('mask-full-mobile');
			let maskFullSrc = maskFull.getAttribute('src');
			this.maskFull = new Image();
			this.maskFull.src = maskFullSrc;
		}


		this.imageWidth = ww;
		this.imageHeight = ww*this.imageRatio;

		this.canvas.width = this.imageWidth;
		this.canvas.height = this.imageHeight;

		if(document.querySelector('.homepage')){

			this.initEvents();
		}
		//Per qualche motivo devo fare questa distinzione, altrimenti non funziona lo scroll update in homepage
		//C'è sicuramente un problema con lo awdScroll.on('call"), ma lascio tutto cosi perchè ora funziona
		else if(document.querySelector('.page-heritage')){
			this.alternative()
		}
	}

	alternative(){
		requestAnimationFrame( () => this.draw() );
	}

	initEvents(){
		awdScroll.on('call', (value, way, obj) => {
			if(value == 'fullCanvas'){
				requestAnimationFrame( () => this.draw() );
			}
		})

	}

	draw(){
		if(this.counter < 200){
			this.counter++;
			let width = (50+this.counter)*this.counter/4;
			let height = width*this.imageRatio;
			let xx = (this.canvas.width - width)/2;
			let yy = (this.canvas.height - height)/2;
			// console.log(this.counter)
			this.ctx.clearRect(0,0,this.canvas.width,this.canvas.height);

			this.ctx.globalCompositeOperation = 'source-over';
			this.ctx.drawImage(this.maskFull,xx,yy,width,height);

			this.ctx.globalCompositeOperation = 'source-in';
			this.ctx.drawImage(this.imageFull,0,0,this.canvas.width,this.canvas.height);
			requestAnimationFrame( () => this.draw() );
		}

	}


}

function initSingleAdv(){
	let pageSingleAdv = document.querySelector('.page-single-adv');
	let title = pageSingleAdv.querySelectorAll('.sezione__title .item-inview-up');
	let galleries = pageSingleAdv.querySelectorAll('.drag-gallery');
	let control = pageSingleAdv.querySelector('.control');
	let txt = pageSingleAdv.querySelector('.sezione__txt .item-inview-up');


	//TIME
	let delayTitle = 0;
	let delayGallery = 0.6;
	let duration = 1.2;

	if(awdScroll){
		awdScroll.stop();
		setTimeout( () => {
			awdScroll.start()
		},500)
	}
	//TITOLO
	title.forEach( titleItem => {
		gsap.to(titleItem,{
			duration: duration,
			delay:delayTitle,
			autoAlpha:1,
			ease:'power1.in'
		})
		gsap.to(titleItem,{
			duration: duration,
			delay:delayTitle,
			y:0,
			ease:'power2.out'
		})
		delayTitle+=0.2;
	})
	//GALLERIES
	galleries.forEach( gallery => {
		gsap.to(gallery,{
			duration: duration,
			delay:delayGallery,
			autoAlpha:1,
			ease:'power1.in'
		})
		gsap.to(gallery,{
			duration: duration,
			delay:delayGallery,
			x:0,
			ease:'power2.out'
		})
		delayGallery+=0.2;
	})
	//CONTROL
	gsap.to(control,{
		duration: duration,
		delay:delayGallery,
		autoAlpha:1
	})
	//TXT
	gsap.to(txt,{
		duration: duration,
		delay:delayGallery,
		autoAlpha:1,
		ease:'power1.in'
	})
	gsap.to(txt,{
		duration: duration,
		delay:delayGallery,
		y:0,
		ease:'power2.out'
	})

}

function initHomepage(){
	let header = document.querySelector('header');
	let sezioneTop = document.querySelector('.sezione-top');
	let sliderSmallWrapper = sezioneTop.querySelector('.slider--small .slider__wrapper');
	let sliderBigWrapper = sezioneTop.querySelector('.slider--big .slider__wrapper');
	let virgolette = sezioneTop.querySelector('.txt__virgolette');
	let anno = sezioneTop.querySelector('.slider__txt-center h3');
	let text = sezioneTop.querySelector('.txt__content');
	let cta = sezioneTop.querySelector('.txt__cta');
	let controls = sezioneTop.querySelector('.controls');
	let dot = controls.querySelector('.dot--center');
	let svgCircle = dot.querySelector('.svg-circle');
	let raggio = dot.getBoundingClientRect().width / 2;
	let svgCircleLargeLength = Math.round(2*Math.PI*raggio);
	let scrollaWrapper = document.querySelector('.scrolla__wrapper');


	let duration = 1;

	if(awdScroll){
		awdScroll.stop();
		setTimeout( () => {
			awdScroll.start()
		},500)
	}

	//SLIDER SMALL
	gsap.to(sliderSmallWrapper,{
		duration:duration,
		x:0,
		ease:'power2.out'
	})
	gsap.to(sliderSmallWrapper,{
		duration:duration,
		autoAlpha:1,
		ease:'power1.in',
		onComplete: () => {
			header.classList.add('active');
		}
	})

	//SLIDER BIG
	gsap.to(sliderBigWrapper,{
		duration:duration,
		x:0,
		delay:0.4,
		ease:'power2.out'
	})
	gsap.to(sliderBigWrapper,{
		duration:duration,
		autoAlpha:1,
		delay:0.4,
		ease:'power1.in'
	})

	//ANNO
	gsap.to(anno,{
		duration:duration,
		y:0,
		delay:1.1,
		ease:'power2.out'
	})
	gsap.to(anno,{
		duration:duration,
		autoAlpha:1,
		delay:1.1,
		ease:'power1.in'
	})

	//VIRGOLETTE
	gsap.to(virgolette,{
		duration:duration,
		y:0,
		delay:0.6,
		ease:'power2.out'
	})
	gsap.to(virgolette,{
		duration:duration,
		autoAlpha:1,
		delay:0.6,
		ease:'power1.in'
	})

	//TESTO SOTTO VIRGOLETTE
	gsap.to(text,{
		duration:duration,
		y:0,
		delay:0.7,
		ease:'power2.out'
	})
	gsap.to(text,{
		duration:duration,
		autoAlpha:1,
		delay:0.7,
		ease:'power1.in'
	})

	//TESTO CENTRALE (SE C'E')
	if(sezioneTop.querySelector('.slider__txt-center')){
		let textCenter = sezioneTop.querySelector('.slider__txt-center p');
		gsap.to(textCenter,{
			duration:duration,
			y:0,
			delay:0.7,
			ease:'power2.out'
		})
		gsap.to(textCenter,{
			duration:duration,
			autoAlpha:1,
			delay:0.7,
			ease:'power1.in'
		})
	}

	//CTA SOTTO VIRGOLETTE
	gsap.to(cta,{
		duration:duration,
		y:0,
		delay:0.8,
		ease:'power2.out'
	})
	gsap.to(cta,{
		duration:duration,
		autoAlpha:1,
		delay:0.8,
		ease:'power1.in'
	})

	//DOTS NAVIGATION
	gsap.to(controls,{
		duration:duration,
		autoAlpha:1,
		delay:1
	})

	//CIRCLE DOT CORRENTE
	gsap.to(svgCircle,{
		duration:1,
		delay:1.2,
		strokeDasharray: svgCircleLargeLength,

	});

	//SCROLLDOWN
	gsap.to(scrollaWrapper,{
		duration:0.8,
		autoAlpha:1,
		delay:1.2
	})

}

// function initHeritage(){
// 	let page = document.querySelector('.page-heritage');
// 	let scrolla = page.querySelector('.scrolla');
// 	let scrollaContainer = scrolla.querySelector('.scrolla');
// 	gsap.to('.scrolla', {
// 		duration:0.8,
// 		autoAlpha:1,
// 		ease:'power1.in'
// 	})
// 	gsap.to('.scrollaContainer', {
// 		duration:0.8,
// 		x:0,
// 		ease:'power2.out'
// 	})

// }

class MouseMoveItem{
	constructor(item, target){
		this.item = item;
		this.container = this.item.closest('.mouse-move-container');
		this.initEvents();
		this.dataDirection = this.item.dataset.direction;
		this.tx = 1;
		if(this.dataDirection === 'left'){
			this.tx = -1;
		}

	}

	initEvents(){
		this.container.addEventListener('mousemove',() => {
			// console.log(mousePos)
			gsap.to(this.item,{
				duration:3,
				ease:'power2.out',
				x: this.tx*(mousePos.x - winsize.width/2) / 15,
				// y: this.tx*(mousePos.y - scrollTop - winsize.height/2) /30
			})
		})

	}
}

class ServizioClienti{
	constructor(){
		this.boxServizioClienti = document.querySelector('.form-servizio-clienti');
		this.formOverlay = this.boxServizioClienti.querySelector('.form__overlay');
		this.chiudiBoxBtn = this.boxServizioClienti.querySelector('.close-form-servizio-clienti');
		this.apriBoxBtn = document.querySelector('.assistenza-btn');

		this.isAnimating = false;

		this.initEvents();
	}

	initEvents(){
		this.apriBoxBtn.addEventListener('click', () => {
			if(this.isAnimating) return;
			this.isAnimating = true;
			body.style.overflow = 'hidden';
			this.mostraFormServizioClienti();
		})
		this.chiudiBoxBtn.addEventListener('click', () => {
			if(this.isAnimating) return;
			this.isAnimating = true;
			body.style.overflow = 'visible';
			this.nascondiFormServizioClienti();
		})
		this.formOverlay.addEventListener('click', () => {
			if(this.isAnimating) return;
			this.isAnimating = true;
			body.style.overflow = 'visible';
			this.nascondiFormServizioClienti();
		})
	}

	mostraFormServizioClienti(){
		gsap.to(this.boxServizioClienti,{
			duration:0.6,
			autoAlpha:1,
			onComplete: () => {
				this.isAnimating = false;
			}
		})
	}

	nascondiFormServizioClienti(){
		gsap.to(this.boxServizioClienti,{
			duration:0.6,
			autoAlpha:0,
			onComplete: () => {
				this.isAnimating = false;
			}
		})
	}
}

function swiperSliderGenericoMobile(){
	// console.log('init swiper')
	if(document.querySelectorAll('.slider-generico-mobile .swiper-container') !== null){
		document.querySelectorAll('.slider-generico-mobile .swiper-container').forEach( container => {
			// console.log(slider)
			let boolLoop = false;
			let spaceBetween = winsize.width / 16;
			// let container = slider.querySelector('.swiper-container');

			let mySwiper = new Swiper (container, {
				slidesPerView: 1.2,
				spaceBetween: spaceBetween,
				grabCursor: true,
				speed:800,
				loop: boolLoop,
			});
		})

	}

	// if(document.querySelector('.slider-generico-mobile .swiper-container') !== null){
	// 	document.querySelectorAll('.slider-generico-mobile .swiper-container').forEach( container => {
	// 		let boolLoop = false;
	// 		let spaceBetween = winsize.width / 16;

	// 		let mySwiper = new Swiper (container, {
	// 			slidesPerView: 1.2,
	// 			spaceBetween: spaceBetween,
	// 			grabCursor: true,
	// 			speed:800,
	// 			loop: boolLoop,
	// 		});
	// 	})
	// }
}
class TransitionLink{
	constructor(link){
		this.link = link;
		this.transitionPage = document.querySelector('.transition-page');
		this.transitionPageBgSpan = this.transitionPage.querySelector('.transition-page__bg span');
		this.transitionTitle = this.transitionPage.querySelector('.transition-page__content .js-title')

		this.isAnimating = false;



		this.initEvents();
	}

	initEvents(){
		let duration = 1.2;
		this.link.addEventListener('click', e => {
			e.preventDefault();
			let nextPageTitle = this.link.dataset.title;
			let nextLink = this.link.getAttribute('href');
			this.transitionTitle.innerHTML = nextPageTitle;
			this.transitionPage.style.display = 'block';
			gsap.to(this.transitionPageBgSpan,{
				duration:duration,
				height:'100%',
				ease:'power2.inOut'
			})
			gsap.set(this.transitionPageBgSpan,{
				top:'0',
				bottom:'auto',
				delay:duration
			})
			gsap.to(this.transitionTitle,{
				duration:duration,
				delay:duration,
				autoAlpha:1,
				ease:'power1.in'
			})
			gsap.to(this.transitionTitle,{
				duration:duration,
				delay:duration,
				y:0,
				ease:'power2.out'
			})
			gsap.to(this.transitionTitle,{
				duration:duration,
				delay:duration+2.2,
				autoAlpha:0,
				y:-80,
				ease:'power2.in',
				onComplete: () => {
					window.location.href = nextLink;
				}
			})
			// gsap.to(this.transitionPageBgSpan,{
			// 	duration:duration,
			// 	delay:duration+1,
			// 	height:'0%',
			// 	ease:'power2.inOut'
			// })

		})
	}
}

function swiperAdv(){
	var spaceBetween = winsize.width / 16;
    var swiperIntro = new Swiper('.sezione-archivi .swiper-container', {
        slidesPerView: 2.2,
        spaceBetween: spaceBetween/2,
        grabCursor: true,
        speed:800,
        loop: true,
		noSwipingSelector:'.cta-rect',
        navigation: {
          nextEl: '.control-next',
          prevEl: '.control-prev',
        },
	});
	swiperIntro.on('transitionEnd', () => {
		if(!isMobile){
			[...document.querySelectorAll('.sezione-archivi .cta-rect')].forEach( cta => {
				if(!cta.classList.contains('inizializzato')){
					cta.classList.add('inizializzato');
					new CtaRect(cta);
				}
			})
		}
	})
}

class SelectCategorieMobile{
	constructor(){
		this.categorieBtn = document.querySelector('.categorie-mobile');
		this.categorieImage = this.categorieBtn.querySelector('.categorie__image');

		this.select = document.querySelector('.select-categorie');
		this.selectWrapper = this.select.querySelector('.select__wrapper');
		this.selectLinks = this.select.querySelector('.select__links');
		this.selectHeight = this.selectLinks.getBoundingClientRect().height;

		this.apriFiltriBtn = document.querySelector('.apri-filtri');

		this.isAnimating = false;

		this.initEvents();
	}

	initEvents(){
		this.categorieBtn.addEventListener('click', () => {
			if(this.isAnimating) return;
			this.isAnimating = true;
			this.selectHeight = this.selectLinks.getBoundingClientRect().height;
			if(this.categorieBtn.classList.contains('opened')){
				this.closeSelect();
				this.categorieBtn.classList.remove('opened');

			}
			else{
				if(this.apriFiltriBtn.classList.contains('opened')){
					classFiltriShop.chiudiFiltri().then( () => {
						body.classList.remove('header-bloccato');
						this.openSelect();
						this.categorieBtn.classList.add('opened');
					})
				}
				else{
					this.openSelect();
					this.categorieBtn.classList.add('opened');
				}

			}
		})
	}

	openSelect(){
		gsap.to(this.selectWrapper,{
			duration:0.6,
			height:this.selectHeight,
			onComplete: () => {
				this.isAnimating = false;
			}
		})
		gsap.to(this.categorieImage,{
			duration:0.6,
			rotation:180
		})
	}
	closeSelect(){
		gsap.to(this.selectWrapper,{
			duration:0.6,
			height:0,
			onComplete: () => {
				this.isAnimating = false;
			}
		})
		gsap.to(this.categorieImage,{
			duration:0.6,
			rotation:0
		})
	}
}

class SiparioContatti{
	constructor(pageContatti){
		this.pageContatti = pageContatti;
		this.center = this.pageContatti.querySelector('.top__center');
		this.form = this.pageContatti.querySelector('.form-sipario');
		this.formBg = this.pageContatti.querySelector('.form-sipario__bg');
		this.formWrapper = this.pageContatti.querySelector('.form-sipario__wrapper');
		this.contattiLegal = this.pageContatti.querySelector('.contatti-legal');

		this.openFormBtn = this.center.querySelector('.cta--open-form');
		this.closeFormBtn = this.form.querySelector('.return');

		this.isAnimating = false;

		this.initEvents();
	}

	initEvents(){
		this.openFormBtn.addEventListener('click', () => {
			if(this.isAnimating) return;
			this.isAnimating = true;
			this.openForm();
		})
		this.closeFormBtn.addEventListener('click', () => {
			if(this.isAnimating) return;
			this.isAnimating = true;
			this.closeForm();
		})
	}

	openForm(){
		let tl = gsap.timeline();
		tl.to(this.center,{
			duration:1,
			autoAlpha:0
		})
		.to(this.form,{
			duration:0,
			display:'block'
		},'-=1')
		.to(this.formWrapper,{
			duration:1,
			autoAlpha:1,
			ease:'power1.in'
		},'-=0.3')
		.to(this.formWrapper,{
			duration:1,
			y:0,
			ease:'power2.out',
			onComplete: () => {
				this.isAnimating = false;
			}
		},'-=1')
		if(isMobile){
			gsap.to(this.contattiLegal,{
				autoAlpha:0,
			})
		}
	}

	closeForm(){
		let tl = gsap.timeline();
		tl.to(this.formWrapper,{
			duration:0.6,
			y:80,
			autoAlpha:0,
			ease:'power1.in'
		})
		.to(this.center,{
			duration:1,
			autoAlpha:1
		},'-=0.1')
		.to(this.form,{
			duration:0,
			display:'none',
			onComplete: () => {
				this.isAnimating = false;
			}
		})
		if(isMobile){
			gsap.to(this.contattiLegal,{
				autoAlpha:1,
				delay:0.5
			})
		}


	}
}


//CUSTOM WOOCOMMERCE
function _customCoupon(){
	$(document).on('click','.submit-custom-coupon',function(){
		let customCoupon = document.querySelector('.custom-coupon');
		let customCouponInput = customCoupon.querySelector('.input');
		let couponCodeValue = document.querySelector('.custom-coupon input').value
		let realCustomCoupon = document.querySelector('.checkout_coupon');
		let realCustomCouponInput = document.querySelector('.checkout_coupon input');
		//set coupon value
		realCustomCouponInput.value = couponCodeValue;
		$('.checkout_coupon').submit()
	})
}

function getRadioButtonValue(){

		// console.log('stringa: ')
		var id = 'iniziale';
		$('input[name="payment_method"]:checked').each(function(){
			var val = $(this).val()
			id = $(this).attr('id')
			// console.log('id',id)
		// console.log($('.fakeInput.'+id))

		})

		// $('input#payment_method_bacs').prop('checked',true)
		TweenMax.set($('.fakeInput.'+id),{className:'+=checked'})
		TweenMax.set($('.fakeInput.checked img.checked'),{autoAlpha:1})

		if(document.querySelector('.wc_payment_method label') !== null){
			[...document.querySelectorAll('.wc_payment_method label')].forEach( label => {
				label.removeEventListener('click', () => {
					var idInput = label.getAttribute('for')
					TweenMax.set($('.fakeInput img.checked'),{autoAlpha:0})
					TweenMax.set($('.fakeInput'),{className:'-=checked'})
					TweenMax.set($('.fakeInput.'+idInput),{className:'+=checked'})
					TweenMax.set($('.fakeInput img.checked'),{autoAlpha:0})
					TweenMax.set($('.fakeInput.checked img.checked'),{autoAlpha:1})
					$('input').prop('checked',false)
					$('input#'+idInput).prop('checked',true)
				},true)
				label.addEventListener('click', () => {
					var idInput = label.getAttribute('for')
					TweenMax.set($('.fakeInput img.checked'),{autoAlpha:0})
					TweenMax.set($('.fakeInput'),{className:'-=checked'})
					TweenMax.set($('.fakeInput.'+idInput),{className:'+=checked'})
					TweenMax.set($('.fakeInput img.checked'),{autoAlpha:0})
					TweenMax.set($('.fakeInput.checked img.checked'),{autoAlpha:1})
					$('input').prop('checked',false)
					$('input#'+idInput).prop('checked',true)
				})
			})


			// $('.wc_payment_method label').on('click',function(){
				// var idInput = $(this).attr('for')
				// TweenMax.set($('.fakeInput img.checked'),{autoAlpha:0})
				// TweenMax.set($('.fakeInput'),{className:'-=checked'})
				// TweenMax.set($('.fakeInput.'+idInput),{className:'+=checked'})
				// TweenMax.set($('.fakeInput img.checked'),{autoAlpha:0})
				// TweenMax.set($('.fakeInput.checked img.checked'),{autoAlpha:1})
				// $('input').prop('checked',false)
				// $('input#'+idInput).prop('checked',true)
			// })
		}




}

//Funzione non più in uso
function readTermsBeforeBuy(){
	//tolgo la propretà disabled al bottone (la metto inizialmente per evitare che qualcuno clicchi prima che sia attivo il prevent default)
	$('button#place_order').prop("disabled", false);
	$(document).on('click','button#place_order',function(e){

		if(!$('.woocommerce-terms-and-conditions-wrapper').hasClass('letto')){
			e.preventDefault()
			TweenMax.to($('.woocommerce-terms-and-conditions-wrapper .text .txt'),0.5,{color:'#f00'})
			TweenMax.to($('.woocommerce-terms-and-conditions-wrapper .text .txt a'),0.5,{color:'#f00'})
		} else {
			TweenMax.to($('.woocommerce-terms-and-conditions-wrapper .text .txt'),0.5,{color:'#000'})
			TweenMax.to($('.woocommerce-terms-and-conditions-wrapper .text .txt a'),0.5,{color:'#000'})
		}


	})
}
//Funzione non più in uso
function toggleTermsCheckbox(){

	$('.woocommerce-terms-and-conditions-wrapper').on('click',function(){
		// document.dispatchEvent(new Event("update_checkout"));
		// document.querySelector('body').dispatchEvent(new Event("update_checkout"));
		// console.log('click')
		if(!$(this).hasClass('letto')){
			// console.log('non ha la classe letto')
			TweenMax.to($(this).find('img.checked'),0.5,{autoAlpha:1})
			TweenMax.to($('.woocommerce-terms-and-conditions-wrapper .text .txt'),0.5,{color:'#000'})
			TweenMax.to($('.woocommerce-terms-and-conditions-wrapper .text .txt a'),0.5,{color:'#000'})
			$(this).addClass('letto')
		} else {
			TweenMax.to($(this).find('img.checked'),0.5,{autoAlpha:0})
			// console.log('ha la classe letto')
			$(this).removeClass('letto')
		}

	})
}
function hoverSubmitButton(){
	if(document.querySelector('#place_order') !== null){
		let btn = document.querySelector('#place_order');

		btn.addEventListener('mouseenter', () => {
			gsap.to(btn,{
				duration:0.3,
				backgroundColor:'transparent',
				color:colorGold
			})
		})

		btn.addEventListener('mouseleave', () => {
			gsap.to(btn,{
				duration:0.3,
				backgroundColor:colorGold,
				color:'#fff'
			})
		})
	}
}


var boolAjaxLoaded = false;
$(document).ajaxComplete(function(event, xhr, ajaxOpts) {

	//Utilizzo un BOOL perchè se richiamo più volte le funzioni si raddoppiano i click
	// if(boolAjaxLoaded) return
	// boolAjaxLoaded = true;

	if(document.querySelector('.page-cassa') !== null){



		// toggleTermsCheckbox()
		// readTermsBeforeBuy()

		if(document.querySelector('.custom-coupon') !== null){
			let customCoupon = document.querySelector('.custom-coupon');
			let customCouponInput = customCoupon.querySelector('.input');
			new InputText(customCouponInput);
		}


		_customCoupon();
		getRadioButtonValue();
		if(!isMobile){
			[...document.querySelectorAll('.cta-rect')].forEach( cta => {
				new CtaRect(cta);
			})
			hoverSubmitButton();
		}

	}


});
class CustomDataLayer {
	constructor() {
		this.ajaxFile = `${homeUrl}/opzione-sito/ajax-custom-datalayer/`;
		this.data = {};
		this.init();
	}
	init() {
		if(document.body.classList.contains('single-product')){
			this.data.product_id = document.querySelector('.product__info .aggiungi').dataset.productId
			this.ajaxCall('view__item', this.data).then((res) => {
				this.singleProductDataLayer(res)
			})
		}

		window.addEventListener('addToCart', (e) => {
			this.data.product_id = e.detail.product
			this.data.size_id = e.detail.size
			this.ajaxCall('add__to_cart', this.data).then((res) => {
				this.addToCartDataLayer(res)
			})
		})

		window.addEventListener('addToWishList', (e) => {
			this.data.product_id = e.detail.product
			this.ajaxCall('add__to_wish', this.data).then((res) => {
				this.addToWishlistDataLayer(res)
			})
		})

		window.addEventListener('removeFromCart', (e) => {
			this.data.element = e.detail.element
			this.ajaxCall('remove__from_cart', this.data).then((res) => {
				this.removeFromCartDataLayer(res)
			})
		})
	}
	singleProductDataLayer(data) {
		window.dataLayer = dataLayer || [];
		//dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "view_item",
			ecommerce: {
				currency: 'EUR',
				value: data.price,
				items: [
					data.result
				]
			}
		});
	}
	addToCartDataLayer(data){
		window.dataLayer = dataLayer || [];
		//dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "add_to_cart",
			ecommerce: {
				currency: 'EUR',
				value: data.price,
				items: [
					data.result
				]
			}
		});
	}
	addToWishlistDataLayer(data){
		window.dataLayer = dataLayer || [];
		//dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "add_to_wishlist",
			ecommerce: {
				currency: 'EUR',
				value: data.price,
				items: [
					data.result
				]
			}
		});
	}
	removeFromCartDataLayer(data){
		window.dataLayer = dataLayer || [];
		//dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "remove_from_cart",
			ecommerce: {
				currency: 'EUR',
				value: data.price,
				items: [
					data.result
				]
			}
		});
	}
	ajaxCall(action, data) {
		return new Promise((resolve, reject) => {
			let formData = new FormData();
			let request = new XMLHttpRequest();
			formData.append('action', action);
			formData.append('data', JSON.stringify(data));

			request.open('POST', this.ajaxFile, true);
			request.onreadystatechange = function () {
				if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
					let res = JSON.parse(request.response);
					if(res.return == 200){
						resolve(res);
					}
				}
			};
			request.send(formData);
		})
	}
}

function checkoutPrivacy() {
	let privacyCheckbox = document.getElementById('privacy_policy_field').querySelector('.privacy-checkbox-checkout')
	let check = document.getElementById('privacy_policy')
	check.addEventListener('change', (ev) => {
		if (ev.currentTarget.checked) {
			privacyCheckbox.classList.add('checked')
		} else {
			privacyCheckbox.classList.remove('checked')
		}
	})
}
document.addEventListener("DOMContentLoaded", () => {

	if(document.querySelector('.page-cassa') !== null){
		jQuery('body').on('updated_checkout', (ev) => {
			if(document.getElementById('privacy_policy_field') !== null){
				checkoutPrivacy()
			}
		})
		jQuery('body').on('payment_method_selected', (ev) => {
			if(document.getElementById('privacy_policy_field') !== null){
				checkoutPrivacy()
			}
		})

	}


	if(isMobile){
		swiperSliderGenericoMobile();
	}

	new CustomDataLayer()

	// if(document.querySelector('.lazy-image-mobile')){
	// 	lazyLoadMobile();
	// }

	smoothscroll.polyfill();

	if(document.querySelector('.form-footer') !== null){
		submitFooterNewsletter()
	}

	if(document.querySelector('.form-popup') !== null){
		cookiePopupNewsletter();
		submitPopupNewsletter();
	}

	clickHamburger();
	// if(document.querySelector('.horizontal-page') !== null){
	// 	// new HorizontalPage();
	// }

	if(document.querySelectorAll('.go-back') !== null){
		goBack();
	}
	// if(document.querySelectorAll('.transition-link') !== null){
		// document.dispatchEvent(new Event("update_checkout"));
        // document.querySelector('body').dispatchEvent(new Event("update_checkout"));
		setTimeout( () =>{
			document.querySelectorAll('.transition-link').forEach( link => {
				new TransitionLink(link);
				// let newListitems = document.querySelectorAll('.transition-link');
				// newListitems.forEach( el => {
					// console.log(link);
				// })
			})
		},1500)
	// }


	setTimeout( () => {
		let direction = 'vertical';
		let scrollbarClass = 'awd-scrollbar'
		if(document.querySelector('.horizontal-page') !== null && !isMobile){
			direction = 'horizontal';
			scrollbarClass = 'awd-scrollbar-horizontal';
		}
		awdScroll = new LocomotiveScroll({
			el: document.querySelector('#container'),
			smooth: true,
			getSpeed: true,
			getDirection: true,
			direction: direction,
			// smoothMobile: true,
			lerp: 0.1,
			scrollbarClass: scrollbarClass
		});

		awdScroll.on('scroll', (instance) => {
			// console.log({instance})
			calcScrollTop(instance);
			calcScrollLeft(instance);
			detectDirection(instance);
		})




		awdScroll.on('call', (value, way, obj) => {

			if(value == 'lazyImageMobile'){
				let el = obj.el;
				if(el.classList.contains('updated')) return;
				el.classList.add('updated');
			}

			// ! Aggiorno le pagine per adattare l'altezza
			if(value == 'updatePage'){
				let el = obj.el;
				if(el.classList.contains('updated')) return;
				el.classList.add('updated');
				awdScroll.update();
			}
			if(value == 'fullCanvas'){
				let el = obj.el;
				if(el.classList.contains('updated')) return;
				el.classList.add('updated');
				if(document.querySelector('.page-heritage')){
					new FullCanvas()
				}
			}
			if(value == 'containerItemInviewUp'){
				let el = obj.el;
				let delay = 0;
				if(el.classList.contains('updated')) return;
				el.classList.add('updated');
				el.querySelectorAll('.stagger-item-inview-up').forEach( inviewEl => {
					gsap.to(inviewEl, {
						duration: 1,
						y: 0,
						delay: delay,
						ease: "power2.Out",
						// stagger: {
						//   grid: [7,15],
						//   from: "center",
						//   each: 0.5
						// }
					});
					gsap.to(inviewEl, {
						duration: 1,
						delay: delay,
						opacity: 1,
						ease: "power1.in",
					});
					delay+=0.05;
				})
			}
			if(value == 'containerItemInviewLeft'){
				let el = obj.el;
				let delay = 0;
				if(el.classList.contains('updated')) return;
				el.classList.add('updated');
				el.querySelectorAll('.stagger-item-inview-left').forEach( inviewEl => {
					gsap.to(inviewEl, {
						duration: 1,
						x: 0,
						delay: delay,
						ease: "power2.Out",
						// stagger: {
						//   grid: [7,15],
						//   from: "center",
						//   each: 0.5
						// }
					});
					gsap.to(inviewEl, {
						duration: 1,
						delay: delay,
						opacity: 1,
						ease: "power1.in",
					});
					delay+=0.05;
				})
			}
			// if(value == 'itemInviewUp'){
			// 	let el = obj.el;
			// 	if(el.classList.contains('updated')) return;
			// 	el.classList.add('updated');
			// }

			if(value == 'animazioneComplessa'){
				let el = obj.el;
				let delay = 0;
				let text = el.querySelector('.txt__content');
				let cta = el.querySelector('.txt__cta');
				if(el.classList.contains('updated')) return;
				el.classList.add('updated');
				el.querySelectorAll('.drag-gallery').forEach( slide => {
					gsap.to(slide,{
						duration:1.6,
						x:0,
						ease:'power2.out',
						delay:delay
					})
					gsap.to(slide,{
						duration:1.6,
						autoAlpha:1,
						ease:'power1.in',
						delay:delay
					})
					delay+=0.3;
				})

				gsap.to(text,{
					duration:1.2,
					delay:0.8,
					y:0,
					ease:'power2.out',
				})
				gsap.to(text,{
					duration:1.2,
					delay:0.8,
					autoAlpha:1,
					ease:'power1.in',
				})

				gsap.to(cta,{
					duration:1.2,
					delay:1,
					y:0,
					ease:'power2.out',
				})
				gsap.to(cta,{
					duration:1.2,
					delay:1,
					autoAlpha:1,
					ease:'power1.in',
				})
			}

		})

		// window.addEventListener('resize', () => {
		// 	awdScroll.update();
		// })

		if(document.querySelector('.awd-form') !== null){
			[...document.querySelectorAll('.awd-form')].forEach( form => {
				// console.log({form})
				new Form(form);
			})
		}


		if(document.querySelector('.cta-rect') !== null){
			[...document.querySelectorAll('.cta-rect')].forEach( cta => {
				new CtaRect(cta);
			})

		}

		if(document.querySelector('.search-page') !== null){
			let form = document.querySelector('.search-page form');
			globalSearchForm = new SearchForm(form);
		}

		if(document.querySelector('header') !== null){
			classHeader = new Header(document.querySelector('header'));
		}

		// if(document.querySelector('.page-heritage') !== null){
		// 	let header =
		// 	awdScroll.on('scroll', () => {
		// 		if(globalDirection === 'right'){
		// 			document.que
		// 		}
		// 	})
		// }

		if(document.querySelector('.page-single-adv') !== null){
			initSingleAdv();
			if(!isMobile){
				swiperAdv();
			}
		}


		// if(document.querySelector('.page-heritage') !== null){
		// 	console.log('heritage')
		// 	initHeritage()
		// }

		if(document.querySelector('.homepage') !== null){

			let mainSliders = document.querySelectorAll('.slider-double');
			[...mainSliders].forEach( slider => {
				new SlideshowDouble(slider);
			})
			//Prima iniziallizzo lo slider, cosi posso selezionare il dot--center dei controlli
			initHomepage();
			if(document.querySelector('canvas') !== null){
				new FullCanvas();
			}
			document.querySelectorAll('.mouse-move-item').forEach( item => {
				new MouseMoveItem(item)
			})
			awdScroll.on('call', (value, way, obj) => {

				if(value === 'homeSpecial'){
					let el = obj.el;
					//TXT TOP
					let txtsTop = el.querySelectorAll('.txt-top__inner');
					//TXT BOTTOM
					let txtsBottom = el.querySelectorAll('.txt-bottom__inner');
					//CONTROLS
					let controls = el.querySelector('.controls');
					let dot = controls.querySelector('.dot--center');
					let svgCircle = dot.querySelector('.svg-circle');
					let raggio = dot.getBoundingClientRect().width / 2;
					let svgCircleLargeLength = Math.round(2*Math.PI*raggio);
					//PNGS
					let pngTop = el.querySelector('.png-top .png__wrapper');
					let pngBottom = el.querySelector('.png-bottom .png__wrapper');
					//BG
					let sfondo = el.querySelector('.sezione__bg span');
					//TIME
					let duration = 1.4;
					let delay = 0.4;
					let delayTxtTop = 0.6;
					let delayTxtBottom = 1;

					if(el.classList.contains('updated')) return;
					el.classList.add('updated');

					//TXT TOP
					txtsTop.forEach(txtTop => {
						gsap.to(txtTop,{
							duration:1,
							autoAlpha:1,
							delay:delayTxtTop,
							ease:'power1.in'
						})
						gsap.to(txtTop,{
							duration:1,
							y:0,
							delay:delayTxtTop,
							ease:'power2.out'
						})
						delayTxtTop+=0.2;
					})
					gsap.to(pngTop,{
						duration:duration,
						width:'100%',
						ease:'power2.inOut'
					})
					gsap.to(pngBottom,{
						duration:duration,
						width:'100%',
						ease:'power2.inOut'
					})
					gsap.to(sfondo,{
						duration:duration,
						width:'100%',
						ease:'power2.inOut'
					})

					el.querySelectorAll('.slider__wrapper').forEach( slider =>{
						gsap.to(slider,{
							duration:duration,
							delay:delay,
							x:0,
							ease:'power2.out'
						})
						gsap.to(slider,{
							duration:duration,
							delay:delay,
							autoAlpha:1,
							ease:'power1.in'
						})
						delay += 0.4;
					})

					//DOTS NAVIGATION
					gsap.to(controls,{
						duration:duration,
						autoAlpha:1,
						delay:1
					})

					//CIRCLE DOT CORRENTE
					gsap.to(svgCircle,{
						duration:1,
						delay:1.2,
						strokeDasharray: svgCircleLargeLength,
					});

					//TXT BOTTOM
					txtsBottom.forEach(txtBottom => {
						gsap.to(txtBottom,{
							duration:1,
							autoAlpha:1,
							delay:delayTxtBottom,
							ease:'power1.in'
						})
						gsap.to(txtBottom,{
							duration:1,
							y:0,
							delay:delayTxtBottom,
							ease:'power2.out'
						})
						delayTxtBottom+=0.2;
					})
				}

				if(value === 'homeFull'){
					let el = obj.el;
					let delay = 1;
					if(el.classList.contains('updated')) return;
					el.classList.add('updated');
					el.querySelectorAll('.stagger-item-inview-up').forEach( inviewEl => {
						gsap.to(inviewEl, {
							duration: 1,
							y: 0,
							delay: delay,
							ease: "power2.Out",
							// stagger: {
							//   grid: [7,15],
							//   from: "center",
							//   each: 0.5
							// }
						});
						gsap.to(inviewEl, {
							duration: 1,
							delay: delay,
							opacity: 1,
							ease: "power1.in",
						});
						delay+=0.15;
					})
				}

				if(value === 'homeStoria'){
					let el = obj.el;
					// let image = el.querySelector('.image');
					let logoC968 = el.querySelector('.titolo-c968 .img');
					let txtSmall = el.querySelector('.txt-small .txt__content');
					let cta = el.querySelector('.txt-small .txt__cta');
					let ctaMobile = el.querySelector('.image__cta-mobile');
					let txtBig = el.querySelectorAll('.txt-big h2');
					let delay = 0;
					if(el.classList.contains('updated')) return;
					el.classList.add('updated');
					txtBig.forEach( h2 => {
						gsap.to(h2,{
							duration:1.2,
							y:0,
							delay:delay,
							ease:'power2.out',
						})
						gsap.to(h2,{
							duration:1.2,
							autoAlpha:1,
							delay:delay,
							ease:'power1.in',
						})
						delay+=0.05;
					})

					// gsap.to(image,{
					// 	duration:1.6,
					// 	delay:0.2,
					// 	x:0,
					// 	ease:'power2.out'
					// })
					// gsap.to(image,{
					// 	duration:1.6,
					// 	delay:0.2,
					// 	autoAlpha:1,
					// 	ease:'power1.in'
					// })

					gsap.to(logoC968,{
						duration:1.2,
						// delay:1,
						y:0,
						ease:'power2.out',
					})
					gsap.to(logoC968,{
						duration:1.2,
						// delay:1,
						autoAlpha:1,
						ease:'power1.in',
					})

					gsap.to(txtSmall,{
						duration:1.2,
						delay:1,
						y:0,
						ease:'power2.out',
					})
					gsap.to(txtSmall,{
						duration:1.2,
						delay:1,
						autoAlpha:1,
						ease:'power1.in',
					})
					gsap.to(ctaMobile,{
						duration:1.2,
						delay:0.4,
						y:0,
						ease:'power2.out',
					})
					gsap.to(ctaMobile,{
						duration:1.2,
						delay:0.4,
						autoAlpha:1,
						ease:'power1.in',
					})
					gsap.to(cta,{
						duration:1.2,
						delay:1.2,
						y:0,
						ease:'power2.out',
					})
					gsap.to(cta,{
						duration:1.2,
						delay:1.2,
						autoAlpha:1,
						ease:'power1.in',
					})

				}

			})


		}

		if(document.querySelector('.scrolla') !== null){
			new Scrolla(document.querySelector('.scrolla'));
		}
		if(document.querySelector('.drag-galleries') !== null){
			[...document.querySelectorAll('.drag-galleries')].forEach( dragGallery => {
				new DragGallery(dragGallery);
			})
		}

		if(document.querySelectorAll('.menu .link') !== null){
			[...document.querySelectorAll('.menu .link')].forEach( item => {
				new MenuItem(item);
			})
		}


		if(document.querySelectorAll('.add-to-wishlist-btn') !== null){
			new WishlistFromListing();
		}

		if(document.querySelector('.page-single-product') !== null){
			new SlideShowProduct(document.querySelector('.product__slider'));
			new ProductPage(document.querySelector('.page-single-product'));
			new ServizioClienti();
			new Taglie();
		}

		if(document.querySelector('.page-login') !== null){
			pageLoginResitrazione();
		}
		if(document.querySelector('.page-shop') !== null){
			if(!isMobile){
				listingProduct();
			}
			classFiltriShop = new FiltriShop(document.querySelector('.filters'));

			if(document.querySelector('.categorie-mobile') !== null){
				classSelectCategorieMobile = new SelectCategorieMobile();
			}
		}

		if(document.querySelector('.page-contatti') !== null){
			new SiparioContatti(document.querySelector('.page-contatti'));
		}
		if(document.querySelector('.page-wishlist') !== null){
			let wishlistItems = document.querySelector('.page-wishlist').querySelectorAll('.list__item');
			if(wishlistItems !== null){
				[...wishlistItems].forEach( item => {
					new ProductPage(item)
				})
			}
			new PageWishlist(document.querySelector('.wishlist__list'))

		}

	},100)

})

